import {
  ActionIcon,
  Alert,
  Badge,
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  Flex,
  Group,
  Indicator,
  MultiSelect,
  NumberFormatter,
  Pill,
  ScrollArea,
  Select,
  SelectProps,
  Stack,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconAdjustmentsHorizontal,
  IconAlertTriangle,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconCalendarDown,
  IconCalendarUp,
  IconCash,
  IconCheck,
  IconClipboardList,
  IconCodeDots,
  IconCopy,
  IconDots,
  IconDownload,
  IconExternalLink,
  IconEye,
  IconListCheck,
  IconMenuOrder,
  IconNumbers,
  IconPhoto,
  IconPhotoCheck,
  IconPhotoUp,
  IconReload,
  IconRocket,
  IconSearch,
  IconStatusChange,
  IconTruckDelivery,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  useDebouncedCallback,
  useIsFirstRender,
  useMediaQuery,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconFileSearch,
  IconSandbox,
  IconTimeDuration15,
  IconUser,
} from "@tabler/icons-react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import {
  keySearchSalesOrderListOnlyRead,
  repositoryPos,
  styleTableMantine,
  styleTableMantineExpress,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { getValueById, isJSON } from "../../_base/helper/FunctionHelper";
import { SocketExtension } from "../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../_base/socket/ToplicList";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { BASE_API_POS } from "../../config";
import { _localization } from "../../config/location";
import { green, olive_green, sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { SelectListItem } from "../../model/SelectListItem";
import DetailsSellView from "./DetailsSellView";
import OrderImageModal from "./OrderImageModal";
import OrderImageUploadModal from "./OrderImageUploadModal";
import { dataCreateSalesOrder } from "./RetailOrder/Model/modelRetailOrder";

// Định nghĩa đúng kiểu dữ liệu
type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

// ===== Ô lọc nhanh / Bộ lọc nâng cao (ghim theo tài khoản) =====
type QuickFilterKind = "text" | "date" | "select" | "multi";
type QuickFilterDef = {
  id: string;
  group: string;
  labelShort: string;
  kind: QuickFilterKind;
  /** các trường trong form tìm kiếm mà ô lọc này ghi vào (giữ nguyên tham số gửi BE) */
  fields: string[];
  /** số cột lưới ô chiếm ở hàng lọc nhanh (mặc định 1) */
  /** độ rộng ở hàng lọc nhanh, tính theo cột (cho phép nửa cột, ví dụ 1.5); mặc định 1 */
  span?: number;
};
const QUICK_FILTER_SCREEN_CODE = "SALE_ORDER_LIST_READONLY";
const QUICK_FILTER_CONFIG_KEY = "QUICK_FILTERS";
const QUICK_FILTER_STORAGE_KEY = "quickFilters:SALE_ORDER_LIST_READONLY";
// Hai ô luôn hiện ở hàng lọc nhanh, không cấu hình ghim được (không có trong drawer, không hiện chip)
const ALWAYS_VISIBLE = ["tuKhoa", "ngayLap"];
const DEFAULT_PINNED = ["maDon", "ttDon", "ttGiaoVan", "ptThanhToan"];
const QUICK_FILTER_GROUPS = [
  "Đơn hàng",
  "Khách hàng",
  "Nhân viên và bộ phận",
  "Giao hàng và thanh toán",
  "Nguồn bán",
];
// Thứ tự trong mảng = thứ tự hiện ở hàng lọc nhanh và trong drawer
const QUICK_FILTER_DEFS: QuickFilterDef[] = [
  {
    id: "tuKhoa",
    group: "Đơn hàng",
    labelShort: "Từ khóa",
    kind: "text",
    fields: ["KeySearch"],
    span: 1.5,
  },
  {
    id: "chiNhanh",
    group: "Đơn hàng",
    labelShort: "Chi nhánh",
    kind: "multi",
    fields: ["ListOrgId"],
  },
  {
    id: "maDon",
    group: "Đơn hàng",
    labelShort: "Mã đơn hàng",
    kind: "text",
    fields: ["OrderNumber"],
  },
  {
    id: "ngayLap",
    group: "Đơn hàng",
    labelShort: "Khoảng ngày lập",
    kind: "date",
    fields: ["StartDate", "EndDate"],
    span: 2,
  },
  {
    id: "ttDon",
    group: "Đơn hàng",
    labelShort: "Trạng thái đơn hàng",
    kind: "select",
    fields: ["orderStatus"],
  },
  {
    id: "ttChung",
    group: "Đơn hàng",
    labelShort: "Trạng thái chung",
    kind: "multi",
    fields: ["ListOrderGeneralStatus"],
  },
  {
    id: "ttKho",
    group: "Đơn hàng",
    labelShort: "Trạng thái kho",
    kind: "multi",
    fields: ["ListOutWardStatus"],
  },
  {
    id: "loaiDon",
    group: "Đơn hàng",
    labelShort: "Loại đơn hàng",
    kind: "select",
    fields: ["OrderType"],
  },
  {
    id: "nguonDon",
    group: "Đơn hàng",
    labelShort: "Loại đơn hàng (web/TMĐT)",
    kind: "select",
    fields: ["IsOnline"],
  },
  {
    id: "chungTuGoc",
    group: "Đơn hàng",
    labelShort: "Mã chứng từ gốc",
    kind: "text",
    fields: ["attribute19"],
  },
  {
    id: "serial",
    group: "Đơn hàng",
    labelShort: "Serial",
    kind: "text",
    fields: ["Serial"],
  },
  {
    id: "voucher",
    group: "Đơn hàng",
    labelShort: "Mã voucher",
    kind: "text",
    fields: ["VourcherCode"],
  },
  {
    id: "sdtKH",
    group: "Khách hàng",
    labelShort: "SĐT khách hàng",
    kind: "text",
    fields: ["Phone"],
  },
  {
    id: "maKH",
    group: "Khách hàng",
    labelShort: "Mã khách hàng",
    kind: "text",
    fields: ["CustomerCode"],
  },
  {
    id: "tenKH",
    group: "Khách hàng",
    labelShort: "Tên khách hàng",
    kind: "text",
    fields: ["CustomerName"],
  },
  {
    id: "mst",
    group: "Khách hàng",
    labelShort: "Mã số thuế",
    kind: "text",
    fields: ["CustomerTaxCode"],
  },
  {
    id: "sdtNguoiMua",
    group: "Nhân viên và bộ phận",
    labelShort: "SĐT người mua",
    kind: "text",
    fields: ["BuyerPhone"],
  },
  {
    id: "sdtNguoiBan",
    group: "Nhân viên và bộ phận",
    labelShort: "SĐT người bán",
    kind: "text",
    fields: ["SalePhone"],
  },
  {
    id: "nguoiHuongSo",
    group: "Nhân viên và bộ phận",
    labelShort: "Người hưởng số",
    kind: "select",
    fields: ["CodeSal"],
  },
  {
    id: "boPhan",
    group: "Nhân viên và bộ phận",
    labelShort: "Bộ phận",
    kind: "multi",
    fields: ["DepartmentId"],
  },
  {
    id: "ttGiaoVan",
    group: "Giao hàng và thanh toán",
    labelShort: "Trạng thái giao vận",
    kind: "multi",
    fields: ["ListShippingStatus"],
  },
  {
    id: "boPhanGiao",
    group: "Giao hàng và thanh toán",
    labelShort: "Bộ phận giao hàng",
    kind: "select",
    fields: ["ShipingVendor"],
  },
  {
    id: "loiGHTK",
    group: "Giao hàng và thanh toán",
    labelShort: "Lỗi GHTK",
    kind: "select",
    fields: ["Attribute42"],
  },
  {
    id: "ngayXuatKho",
    group: "Giao hàng và thanh toán",
    labelShort: "Ngày xuất kho",
    kind: "date",
    fields: ["OwDate"],
  },
  {
    id: "tgHoanThanh",
    group: "Giao hàng và thanh toán",
    labelShort: "Thời gian hoàn thành",
    kind: "date",
    fields: ["FinishDate"],
  },
  {
    id: "ptThanhToan",
    group: "Giao hàng và thanh toán",
    labelShort: "PT thanh toán",
    kind: "multi",
    fields: ["ListPaymentMethod"],
  },
  {
    id: "kiemTraAnh",
    group: "Giao hàng và thanh toán",
    labelShort: "Kiểm tra ảnh giao hàng",
    kind: "select",
    fields: ["ImageChecked"],
  },
  {
    id: "kenhBan",
    group: "Nguồn bán",
    labelShort: "Kênh bán",
    kind: "select",
    fields: ["saleChannelId"],
  },
  {
    id: "utm",
    group: "Nguồn bán",
    labelShort: "Marketing (UTM)",
    kind: "select",
    fields: ["HasAttribute86"],
  },
];
const QUICK_FILTER_IDS = QUICK_FILTER_DEFS.map((d) => d.id);
// Lọc bỏ id lạ và id luôn hiện (ALWAYS_VISIBLE), xếp lại theo thứ tự catalog; trả null nếu dữ liệu không phải mảng
const normalizePinned = (ids: unknown): string[] | null => {
  if (!Array.isArray(ids)) return null;
  const known = ids.filter(
    (x): x is string =>
      typeof x === "string" &&
      QUICK_FILTER_IDS.includes(x) &&
      !ALWAYS_VISIBLE.includes(x),
  );
  return QUICK_FILTER_IDS.filter((id) => known.includes(id));
};
const readPinnedFromStorage = (): string[] => {
  try {
    const raw = localStorage.getItem(QUICK_FILTER_STORAGE_KEY);
    if (!raw) return DEFAULT_PINNED;
    const parsed = JSON.parse(raw);
    return normalizePinned(parsed?.pinned ?? parsed) ?? DEFAULT_PINNED;
  } catch {
    return DEFAULT_PINNED;
  }
};
const writePinnedToStorage = (ids: string[]) => {
  try {
    localStorage.setItem(
      QUICK_FILTER_STORAGE_KEY,
      JSON.stringify({ v: 1, pinned: ids }),
    );
  } catch {
    // localStorage bị chặn: bỏ qua, vẫn dùng state
  }
};

const SalesOrderListListReturn = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //#region  table

  //data and fetching state
  const [isHaveNewOrder, setIsHaveNewOrder] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [dataDepartment, setDataDepartment] = useState<any[]>([]);
  // Giá trị lọc Trạng thái giao vận - fix cứng; value = mã lưu ở SHIPPING_STATUS,
  // label tiếng Việt lấy theo getDataStatus() ở GeneralSalesStatement / ListOrderTMDTV2
  const dataShippingStatus = [
    { value: "THANH_CONG", label: "Thành công" },
    { value: "PHAN_CONG", label: "Phân công" },
    { value: "TAO_MOI", label: "Tạo mới" },
    { value: "THAT_BAI_DO_KH", label: "Thất bại do khách hàng" },
    { value: "NHAP_LAI", label: "Nhập lại" },
    { value: "DANG_GIAO", label: "Đang giao" },
    { value: "DEN_NOI", label: "Đến nơi" },
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "HUY_PHAN_CONG", label: "Hủy phân công" },
    { value: "THAT_BAI_DO_HACOM", label: "Thất bại do HACOM" },
    { value: "TIEP_NHAN", label: "Tiếp nhận" },
    { value: "NHAP_LAI_MOT_PHAN", label: "Nhập lại một phần" },
    { value: "NOI_CHUYEN", label: "Nối chuyến" },
    { value: "KHONG_YEU_CAU", label: "Không yêu cầu" },
    { value: "HUY_DON", label: "Hủy đơn" },
  ];
  // Tên tiếng Việt của mã trạng thái giao vận, dùng chung cho ô lọc và badge trên lưới;
  // null coi là KHONG_YEU_CAU như trước, mã không có trong danh sách thì hiện nguyên mã
  const getShippingStatusLabel = (code: any) => {
    const _code = code === null ? "KHONG_YEU_CAU" : code;
    return (
      dataShippingStatus.find((item) => item.value === _code)?.label ?? _code
    );
  };
  // Giá trị lọc PT thanh toán (attribute24) - fix cứng theo danh sách ở màn tạo đơn
  const dataPaymentMethod = [
    "Thu Tiền Ngay",
    "Thu tiền sau lắp đặt",
    "Giao Hàng Thu Tiền(COD)",
    "Đã chuyển khoản",
    "Trả góp",
    "Đối Trừ Công Nợ",
    "Công nợ nội bộ",
    "Công Nợ 3 Ngày",
    "Công Nợ 4 Ngày",
    "Công Nợ 5 Ngày",
    "Công Nợ 7 Ngày",
    "Công Nợ 10 Ngày",
    "Công Nợ 15 Ngày",
    "Công Nợ 20 Ngày",
    "Công Nợ 21 Ngày",
    "Công Nợ 30 Ngày",
  ].map((item) => ({ value: item, label: item }));
  const dataChannel = [
    {
      text: "Lazada",
      value: "304",
    },
    {
      text: "Tiktok",
      value: "341",
    },
    {
      text: "Chat Zalo",
      value: "343",
    },
    {
      text: "Facebook",
      value: "62",
    },
    {
      text: "Shopee Mall",
      value: "63",
    },
    {
      text: "Shopee",
      value: "342",
    },
    {
      text: "Tổng đài",
      value: "66",
    },
    {
      text: "Khách đến showroom",
      value: "67",
    },
    {
      text: "Khách đặt đơn Website",
      value: "68",
    },
    {
      text: "Khách gọi điện cho nhân viên",
      value: "69",
    },
    {
      text: "Khách chat qua website",
      value: "101",
    },
  ];
  const shopeeSaleChannelIds = ["342"];
  const isShopeeSaleChannel = (...values: any[]) =>
    values.some((value) => {
      const saleChannel = value?.toString().trim().toLowerCase();
      return (
        saleChannel === "shopee" || shopeeSaleChannelIds.includes(saleChannel)
      );
    });
  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "Có nhập lại", value: "CO_NHAP_LAI" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];
  const [dataListCustomer, setDataListCustomer] = useState<SelectListItem[]>(
    [],
  );

  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);

  const [selectedCustomer, setSelectedCustomer] = useState<string | null>(null);

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);

  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [height, setHeight] = useState(0);
  const debounceTimeoutRef = React.useRef<number | null>(null);
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  const [value, setValue] = useState<[Date | null, Date | null]>([null, null]);
  const firstRender = useIsFirstRender();
  const _searchJson = localStorage.getItem(keySearchSalesOrderListOnlyRead)
    ? JSON.parse(localStorage.getItem(keySearchSalesOrderListOnlyRead) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const isSearchedRef = React.useRef(false);
  const userLoginInfo = localStorage.getItem("userLogin")
    ? JSON.parse(localStorage.getItem("userLogin") || "{}")
    : null;
  const isAccountant = userLoginInfo?.isAccountant ?? false;

  const innitSearchReturn = React.useMemo(
    () => ({
      StartDate:
        firstRender && _searchJson && checkedPinSearch
          ? new Date(_searchJson.StartDate as string)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      EndDate:
        firstRender && _searchJson && checkedPinSearch
          ? new Date(_searchJson.EndDate as string)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      CustomerName:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CustomerName as string)
          : "",
      CustomerCode:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CustomerCode as string)
          : "",
      CustomerTaxCode:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CustomerTaxCode as string)
          : "",
      Serial:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Serial as string)
          : "",
      OrderNumber:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.OrderNumber as string)
          : "",
      Phone:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Phone as string)
          : "",
      KeySearch:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.KeySearch as string)
          : "",
      //Người hưởng số
      CodeSal:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CodeSal as string)
          : "",
      //Bộ phận giao hàng
      ShipingVendor:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.ShipingVendor as string)
          : "",
      //Thời gian hoàn thành đơn
      FinishDate:
        firstRender && _searchJson && _searchJson.FinishDate && checkedPinSearch
          ? new Date(_searchJson.FinishDate)
          : null,
      //Ngày xuất kho
      OwDate:
        firstRender && _searchJson && _searchJson.OwDate && checkedPinSearch
          ? new Date(_searchJson.OwDate)
          : null,
      // Số điện thoại người bán
      SalePhone:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SalePhone
          : "",
      //Số điện thoại người bán
      BuyerPhone:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.BuyerPhone
          : "",
      // Mã voucher
      VourcherCode:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.VourcherCode
          : "",
      //Lỗi GHTK
      Attribute42:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Attribute42 as string)
          : null,
      //Loại đơn hàng
      OrderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderType
          : "",
      IsOnline:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.IsOnline
          : null,
      attribute19:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.attribute19 as string)
          : "",
      saleChannelId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.saleChannelId as string)
          : "",
      // Thông tin Marketing (UTM)
      HasAttribute86:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.HasAttribute86
          : "",
      // Ảnh giao hàng đã kiểm tra chưa ("Y" / "N")
      ImageChecked:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.ImageChecked ?? "")
          : "",
      DepartmentId:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.DepartmentId
          ? Array.isArray(_searchJson.DepartmentId)
            ? _searchJson.DepartmentId
            : []
          : [],
      //Trạng thái giao vận (chọn nhiều)
      ListShippingStatus:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        Array.isArray(_searchJson.ListShippingStatus)
          ? (_searchJson.ListShippingStatus as string[])
          : ([] as string[]),
      //PT thanh toán (chọn nhiều)
      ListPaymentMethod:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        Array.isArray(_searchJson.ListPaymentMethod)
          ? (_searchJson.ListPaymentMethod as string[])
          : ([] as string[]),
      //Trạng thái chung (chọn nhiều)
      ListOrderGeneralStatus:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        Array.isArray(_searchJson.ListOrderGeneralStatus)
          ? (_searchJson.ListOrderGeneralStatus as string[])
          : ([] as string[]),
      //Trạng thái kho (chọn nhiều)
      ListOutWardStatus:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        Array.isArray(_searchJson.ListOutWardStatus)
          ? (_searchJson.ListOutWardStatus as string[])
          : ([] as string[]),
      //Chi nhánh (chọn nhiều)
      ListOrgId:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        Array.isArray(_searchJson.ListOrgId)
          ? (_searchJson.ListOrgId as string[])
          : ([] as string[]),
      orderStatus:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.orderStatus as string)
          : "",
      SourceOrderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SourceOrderType
          : false,
    }),
    [firstRender, _searchJson, checkedPinSearch],
  );

  const innitStateSearch = {
    invId: "",
    invOutwardId: "",
    customerId: "",
    StartDate: "",
    EndDate: "",
    orderStatus: "",
    orderType: "",
    orderNumber: "",
    paymentStatus: "",
    industry: "",
    keySearch: "",
    OutwardStatus: "",
    codeCustomer: "",
    phone: "",
    createBy: "",
    isOnline: "",
    BuyerPhone: "",
    attribute19: "",
    saleChannelId: "",
    DepartmentId: [],
  };

  const [search, setSearch] = useState({
    ...innitStateSearch,
  });

  // Ô lọc đang ghim ra hàng lọc nhanh: đọc local trước, server trả về sau sẽ ghi đè
  const [pinned, setPinned] = useState<string[]>(() => readPinnedFromStorage());
  const [drawerOpened, setDrawerOpened] = useState(false);
  // Đổi key để các input uncontrolled đọc lại giá trị form (sau khi drawer đóng / đặt lại)
  const [quickRowKey, setQuickRowKey] = useState(0);
  const [drawerKey, setDrawerKey] = useState(0);
  // Chỉ để render lại chip "Đang lọc thêm" khi người dùng gõ vào form (debounce)
  const [, setValuesVersion] = useState(0);
  const bumpValuesVersion = useDebouncedCallback(
    () => setValuesVersion((v) => v + 1),
    300,
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitSearchReturn,
    onValuesChange: () => bumpValuesVersion(),
  });

  const [refreshKeySearch, setRefreshKeySearch] = useState<any>({});

  const [orderNumberSearch, setOrderNumberSearch] = useState("");
  const [keySearchWord, setKeySearchWord] = useState("");

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      const orderHeader = response.data?.orderHeader;
      const isShopeeOrder = isShopeeSaleChannel(
        row.original.saleChannelId,
        orderHeader?.saleChanelId,
        orderHeader?.saleChannelId,
        orderHeader?.ten_Kenh,
        orderHeader?.saleChannelName,
      );

      if (isShopeeOrder) {
        navigate("/sell/retail-order-tmdt", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
            fromTMDTList: true,
          },
        });
        return;
      }
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
            // isReadOnly:
            //   location?.pathname === "/sell/sales-order-list-read-only"
            //     ? true
            //     : false,
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
            // isReadOnly:
            //   location?.pathname === "/sell/sales-order-list-read-only"
            //     ? true
            //     : false,
          },
        });
      }
    }
  };

  const handleOpenSharedLink = async (orderNumber: string) => {
    try {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${orderNumber}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response?.success) {
        try {
          const customerData = JSON.parse(
            response.data?.orderHeader?.attribute1 || "{}",
          );

          if (customerData.sharedLink) {
            // Mở link trong tab mới
            window.open(customerData.sharedLink, "_blank");
          } else {
            NotificationExtension.Fails("Không tìm thấy link chia sẻ");
          }
        } catch (parseError) {
          console.error("Error parsing attribute1:", parseError);
          NotificationExtension.Fails("Lỗi phân tích dữ liệu");
        }
      } else {
        NotificationExtension.Fails("Không thể lấy thông tin đơn hàng");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      NotificationExtension.Fails("Lỗi khi lấy thông tin đơn hàng");
    }
  };

  const getTextStatus = (row: any) => {
    return orderStatuses.find(
      (status) => status.value === row.original.orderStatus,
    )?.label;
  };

  const getShippingVendorText = (shippingVendor: string) => {
    switch (shippingVendor) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "HACOM":
        return "Nội bộ";
      default:
        return shippingVendor;
    }
  };

  const fetchData = async (isFromSearchAction = true) => {
    if (isFromSearchAction) {
      isSearchedRef.current = true;
    }

    if (!isAccountant && !isSearchedRef.current) {
      return;
    }

    if (form.getValues()?.StartDate && form.getValues()?.EndDate) {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);
      let queryParams = {
        Skip:
          firstRender && _searchJson
            ? _searchJson.Skip
            : pagination.pageIndex * pagination.pageSize,
        Take:
          firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
      } as any;

      try {
        // const queryParams = {
        //   Skip: pagination.pageIndex * pagination.pageSize,
        //   Take: pagination.pageSize,
        //   InvId: search.invId,
        //   InvOutwardId: search.invOutwardId,
        //   CustomerId: search.customerId,
        //   StartDate: search.startDate,
        //   EndDate: search.endDate,
        //   OrderStatus: search.orderStatus,
        //   OrderType: search.orderType ? Number.parseInt(search.orderType) : 0,
        //   OrderNumber: search.orderNumber,
        //   PaymentStatus: search.paymentStatus,
        //   industry: search.industry,
        //   OutwardStatus: search?.OutwardStatus,
        //   KeySearch: search.keySearch,
        //   CodeCustomer: search.codeCustomer, // Thêm trường tìm kiếm mã khách hàng
        //   Phone: search.phone, // Thêm trường tìm kiếm số điện thoại
        //   CreateBy: search.createBy, // Thêm trường tìm kiếm người tạo
        // };
        const search = form.getValues();
        const IsEcommerce =
          search.IsOnline && search.IsOnline === "IsEcommerce"
            ? "true"
            : "false";
        queryParams = {
          ...queryParams,
          Skip: pagination.pageIndex * pagination.pageSize,
          Take: pagination.pageSize,
          CustomerName: search.CustomerName
            ? search.CustomerName?.toString()
            : "",
          CustomerCode: search.CustomerCode
            ? search.CustomerCode?.toString()
            : "",
          CustomerTaxCode: search.CustomerTaxCode
            ? search.CustomerTaxCode?.toString()
            : "",
          Serial: search.Serial ? search.Serial?.toString() : "",
          OrderNumber: search.OrderNumber
            ? search.OrderNumber?.toString()?.toUpperCase()
            : "",
          Phone: search.Phone ? search.Phone?.toString().trim() : "",
          KeySearch: search.KeySearch ? search.KeySearch?.toString() : "",
          StartDate: search.StartDate
            ? new Date(search.StartDate)?.toISOString()
            : "",
          EndDate: search.EndDate
            ? new Date(search.EndDate)?.toISOString()
            : "",
          CodeSal: search.CodeSal ? search.CodeSal?.toString() : "", // Người hưởng số
          ShipingVendor: search.ShipingVendor
            ? search.ShipingVendor?.toString()
            : "", // Bộ phận giao hàng
          FinishDate: search.FinishDate
            ? moment(search?.FinishDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "", //Thời gian hoàn thành đơn
          OwDate: search.OwDate
            ? moment(search?.OwDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "", //ngày xuất kho
          SalePhone: search.SalePhone?.toString(), // Số điện thoại người bán
          VourcherCode: search.VourcherCode?.toString(), // Mã voucher
          Attribute42: search.Attribute42 ? search.Attribute42?.toString() : "", //Lỗi GHTK
          OrderType: search.OrderType ? search.OrderType?.toString() : "", // Loại đơn hàng
          IsOnline:
            search.IsOnline && search.IsOnline !== "IsEcommerce"
              ? search.IsOnline
              : "",
          BuyerPhone: search.BuyerPhone ? search.BuyerPhone : "",
          attribute19: search.attribute19 ? search.attribute19 : "",
          saleChannelId: search?.saleChannelId ? search?.saleChannelId : "",
          HasAttribute86: search.HasAttribute86
            ? search.HasAttribute86?.toString()
            : "",
          ImageChecked: search.ImageChecked ? search.ImageChecked : "", // Ảnh giao hàng đã kiểm tra: Y / N
          DepartmentId:
            search?.DepartmentId &&
            Array.isArray(search.DepartmentId) &&
            search.DepartmentId.length > 0
              ? search.DepartmentId
              : [],
          orderStatus: search?.orderStatus ? search?.orderStatus : "",
          ListShippingStatus: Array.isArray(search?.ListShippingStatus)
            ? search.ListShippingStatus
            : [],
          ListPaymentMethod: Array.isArray(search?.ListPaymentMethod)
            ? search.ListPaymentMethod
            : [],
          ListOrderGeneralStatus: Array.isArray(search?.ListOrderGeneralStatus)
            ? search.ListOrderGeneralStatus
            : [],
          ListOutWardStatus: Array.isArray(search?.ListOutWardStatus)
            ? search.ListOutWardStatus
            : [],
          ListOrgId: Array.isArray(search?.ListOrgId) ? search.ListOrgId : [],
          SourceOrderType: search?.SourceOrderType ? "4" : "",
        };
        let url;

        if (location?.pathname === "/sell/sales-order-list-read-only") {
          const departmentIds = queryParams.DepartmentId || [];
          const otherParams = Object.entries({
            ...queryParams,
            Skip: pagination.pageIndex * pagination.pageSize,
            Take: pagination.pageSize,
            IsEcommerce: IsEcommerce,
          })
            .filter(([key, value]) => {
              // Bỏ qua DepartmentId và các trường rỗng, trừ Skip và Take
              return (
                key !== "DepartmentId" &&
                key !== "ListShippingStatus" &&
                key !== "ListPaymentMethod" &&
                key !== "ListOrderGeneralStatus" &&
                key !== "ListOutWardStatus" &&
                key !== "ListOrgId" &&
                ((value !== undefined && value !== "") ||
                  key === "Skip" ||
                  key === "Take")
              );
            })
            .map(
              ([key, value]) => `${key}=${encodeURIComponent(String(value))}`,
            )
            .join("&");

          const departmentParams =
            Array.isArray(departmentIds) && departmentIds.length > 0
              ? departmentIds
                  .map((id) => `DepartmentId=${encodeURIComponent(id)}`)
                  .join("&")
              : "";

          url =
            "/api/v1/CreateSellItem/get-list-return-sale?" +
            otherParams +
            (departmentParams ? "&" + departmentParams : "") +
            buildListParams(
              "ListShippingStatus",
              queryParams.ListShippingStatus,
            ) +
            buildListParams(
              "ListPaymentMethod",
              queryParams.ListPaymentMethod,
            ) +
            buildListParams(
              "ListOrderGeneralStatus",
              queryParams.ListOrderGeneralStatus,
            ) +
            buildListParams(
              "ListOutWardStatus",
              queryParams.ListOutWardStatus,
            ) +
            buildListParams("ListOrgId", queryParams.ListOrgId);
        } else {
          const departmentIds = queryParams.DepartmentId || [];
          const otherParams = Object.entries(queryParams)
            .filter(
              ([key, value]) =>
                key !== "DepartmentId" &&
                key !== "ListShippingStatus" &&
                key !== "ListPaymentMethod" &&
                key !== "ListOrderGeneralStatus" &&
                key !== "ListOutWardStatus" &&
                key !== "ListOrgId" &&
                value !== undefined &&
                value !== "",
            )
            .map(
              ([key, value]) => `${key}=${encodeURIComponent(String(value))}`,
            )
            .join("&");

          const departmentParams =
            Array.isArray(departmentIds) && departmentIds.length > 0
              ? departmentIds
                  .map((id) => `DepartmentId=${encodeURIComponent(id)}`)
                  .join("&")
              : "";

          url =
            "/api/v1/CreateSellItem/get-list?" +
            otherParams +
            (departmentParams ? "&" + departmentParams : "") +
            buildListParams(
              "ListShippingStatus",
              queryParams.ListShippingStatus,
            ) +
            buildListParams(
              "ListPaymentMethod",
              queryParams.ListPaymentMethod,
            ) +
            buildListParams(
              "ListOrderGeneralStatus",
              queryParams.ListOrderGeneralStatus,
            ) +
            buildListParams(
              "ListOutWardStatus",
              queryParams.ListOutWardStatus,
            ) +
            buildListParams("ListOrgId", queryParams.ListOrgId);
        }

        const response = await repositoryPos.get<MessageResponse<any>>(url);

        if (response && response.success) {
          setData(response.data?.pagedList?.lists);
          setRowCount(response.totalCount);
          table.resetRowSelection();
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
        localStorage.setItem(
          keySearchSalesOrderListOnlyRead,
          JSON.stringify(queryParams),
        );
      }
    } else {
      NotificationExtension.Fails("Vui lòng chọn khoảng thời gian tìm kiếm !");
    }
  };
  // Nối tham số dạng danh sách (key=a&key=b) cho các ô lọc chọn nhiều
  const buildListParams = (key: string, values: any) =>
    Array.isArray(values) && values.length > 0
      ? values
          .map((v: any) => `&${key}=${encodeURIComponent(String(v))}`)
          .join("")
      : "";

  const handleChangeSearchValue = useDebouncedCallback(
    (value: string, key: string) => {
      const trimmedValue = value.trim();

      if (key === "customerId") {
        setSelectedCustomer(trimmedValue);
      }

      if (key === "OutwardStatus") {
        setSearch((prevData) => ({
          ...prevData,
          [key]: trimmedValue,
          orderStatus: "DON_HANG_HOAN_THANH",
        }));
      }

      setSearch((prevData) => ({ ...prevData, [key]: trimmedValue }));
    },
    500,
  );

  const orderTypes = [
    { value: "1", label: "Bán buôn", color: "yellow" },
    { value: "2", label: "Bán lẻ", color: "indigo" },
    { value: "3", label: "Đơn đổi trả", color: "green" },
    { value: "4", label: "Đơn online", color: "blue" },
  ];

  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_CHO_DUYET_DOI_TRA", label: "Đơn chờ duyệt đổi trả" },
    { value: "DON_DA_DUYET_DOI_TRA", label: "Đơn đã duyệt đổi trả" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];

  // Danh sách option của các ô lọc (dùng chung cho control và nhãn chip "Đang lọc thêm")
  const isOnlineOptions = [
    { label: "Đơn hàng", value: "false" },
    { label: "Đơn hàng website", value: "true" },
    { label: "Đơn hàng TMĐT", value: "IsEcommerce" },
  ];
  const attribute42Options = [{ label: "Có lỗi GHTK", value: "1" }];
  const hasAttribute86Options = [
    { label: "Có UTM (Marketing)", value: "1" },
    { label: "Không UTM", value: "0" },
  ];
  const imageCheckedOptions = [
    { label: "Ảnh đã kiểm tra", value: "Y" },
    { label: "Ảnh chưa kiểm tra", value: "N" },
  ];
  const shippingVendorOptions = [
    "Kỹ thuật",
    "NV điều vận",
    "COD",
    "Kỹ thuật thi công",
    "Dự án",
    "Giao hàng tiết kiệm",
    "Ahamove",
  ];
  const saleChannelOptions = [
    { label: "Lazada", value: "304" },
    { label: "Tiktok", value: "341" },
    { label: "Chat Zalo", value: "343" },
    { label: "Facebook", value: "62" },
    { label: "Shopee Mall", value: "63" },
    { label: "Shopee", value: "342" },
    { label: "Tổng đài", value: "66" },
    { label: "Khách đến showroom", value: "67" },
    { label: "Khách đặt đơn Website", value: "68" },
    { label: "Khách gọi điện cho nhân viên", value: "69" },
    { label: "Khách chat qua website", value: "101" },
  ];
  // Trạng thái kho: 5 mã kho + "Chưa yêu cầu" (lưới hiển thị cho đơn chưa có trạng thái kho)
  const warehouseStatusOptions = [
    ...warehouseStatus,
    { value: "CHUA_YEU_CAU", label: "Chưa yêu cầu" },
  ];
  // Trạng thái chung: cùng mã/nhãn với cột trên lưới, thêm DON_HANG_DONG có trong dữ liệu đơn
  const generalStatusOptions = [
    ...dataStatusGeneral,
    { label: "Đơn hàng đóng", value: "DON_HANG_DONG" },
  ];
  // Chi nhánh lập đơn: danh sách chi nhánh đã tải sẵn (TblDmInventory/get-select-branch), value = Id TblDmMasterOrg = ORG_ID
  const branchOptions = dataBranch.map((b) => ({
    value: String(b.value),
    label: `${b.att2} - ${b.text}`,
  }));

  const openModal = (document: any, amount: number, order: string) =>
    modals.openConfirmModal({
      title: <Title order={4}>Danh sách sản phẩm trong đơn: {order}</Title>,
      children: <DetailsSellView e={document} amount={amount} />,
      size: "100%",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  // Đăng ảnh giao hàng: tải ảnh lên CDN rồi lưu link vào đơn
  const openUploadImageModal = (orderNumber: string) =>
    modals.openConfirmModal({
      title: <Title order={5}>Đăng ảnh giao hàng đơn: {orderNumber}</Title>,
      children: (
        <OrderImageUploadModal
          orderNumber={orderNumber}
          onUploaded={() => fetchData(false)}
        />
      ),
      size: "xl",
      radius: "md",
      centered: true,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  // Xem ảnh chụp lúc giao hàng của đơn
  const openImageModal = (orderNumber: string, videoChecked: string | null) =>
    modals.openConfirmModal({
      title: <Title order={5}>Ảnh giao hàng đơn: {orderNumber}</Title>,
      children: (
        <OrderImageModal
          orderNumber={orderNumber}
          videoChecked={videoChecked}
          // Tải lại danh sách để lấy trạng thái kiểm tra mới từ server
          onChecked={() => fetchData(false)}
        />
      ),
      size: "80%",
      radius: "md",
      centered: true,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const isValidDate = (dateStr: any) => {
    if (!dateStr) return false;
    const m = moment(dateStr);
    return m.isValid() && m.year() > 1970;
  };

  const handleCopyOrder = (originalRow: any) => {
    const rawOldDate = [
      originalRow?.creationDate,
      originalRow?.createDate,
      originalRow?.orderDate,
    ].find((d) => isValidDate(d));

    const isOldDateDifferent =
      rawOldDate && !moment(rawOldDate).isSame(moment(), "day");

    modals.openConfirmModal({
      title: <Title order={4}>Xác nhận sao chép đơn hàng</Title>,
      centered: true,
      size: isOldDateDifferent ? "580px" : "480px",
      children: (
        <Box py="xs">
          <Text size="md" lh={1.6}>
            Bạn có chắc chắn muốn sao chép đơn hàng{" "}
            <Text span fw={700} c="blue" size="lg">
              {originalRow.orderNumber}
            </Text>{" "}
            thành đơn hàng mới ở trạng thái nháp không?
          </Text>
          {isOldDateDifferent && (
            <Alert
              mt="md"
              p="md"
              color="orange"
              variant="light"
              icon={<IconAlertTriangle size={24} />}
              title={
                <Text fw={700} size="md">
                  Lưu ý ngày đơn hàng
                </Text>
              }
            >
              <Text size="md" lh={1.6}>
                Đơn hàng gốc được tạo ngày{" "}
                <Text span fw={700}>
                  {moment(rawOldDate).format("DD/MM/YYYY")}
                </Text>
                , khác với ngày hiện tại (
                <Text span fw={700}>
                  {moment().format("DD/MM/YYYY")}
                </Text>
                ).
              </Text>
              <Text size="md" mt={8} fw={700} c="orange.9" lh={1.6}>
                Vui lòng kiểm tra lại giá bán và các chính sách giá của sản phẩm
                khi tạo đơn mới!
              </Text>
            </Alert>
          )}
        </Box>
      ),
      labels: { confirm: "Xác nhận", cancel: "Hủy" },
      confirmProps: { color: "blue", size: "md" },
      cancelProps: { size: "md" },
      onConfirm: async () => {
        setIsLoading(true);
        try {
          // 1. Lấy thông tin chi tiết đầy đủ của đơn hàng gốc
          const detailsUrl = `/api/v1/CreateSellItem/details?orderNumber=${originalRow.orderNumber}`;
          const detailsResponse =
            await repositoryPos.get<MessageResponse<any>>(detailsUrl);

          if (!detailsResponse || !detailsResponse.success) {
            NotificationExtension.Fails(
              detailsResponse?.message ||
                "Không lấy được thông tin chi tiết của đơn hàng gốc!",
            );
            return;
          }

          const originalHeader =
            detailsResponse.data?.orderHeader || originalRow;
          const originalDetail =
            detailsResponse.data?.orderDetail || originalRow?.orderDetail || [];

          // 2. Lấy mã đơn hàng mới
          const prefix = originalRow?.orderNumber?.startsWith("ON")
            ? "ON"
            : "DH";
          const createHeaderResponse = await repositoryPos.get<
            MessageResponse<any>
          >(`/api/v1/CreateSellItem/create?codePrefix=${prefix}`);

          const draftHeader = createHeaderResponse?.data?.orderHeader;

          if (!createHeaderResponse?.success || !draftHeader?.orderNumber) {
            NotificationExtension.Fails(
              createHeaderResponse?.message ||
                "Không lấy được mã đơn hàng mới!",
            );
            return;
          }

          // 3. Chuẩn bị danh sách sản phẩm cho đơn nháp mới
          const draftOrderDetail = (originalDetail || []).map((item: any) => ({
            ...item,
            id: item.itemId || item.id || 0,
            orderHeaderId: 0,
            totalLineAmount:
              item.totalLineAmount ??
              (item.priceFinal || 0) * (item.quality || 0),
            deptId: originalHeader?.deptId ?? item.deptId,
            createBy: 0,
            createDate: "",
            lastUpdateBy: 0,
            lastUpdateDate: "",
          }));

          // 4. Chuẩn bị header cho đơn nháp mới với dữ liệu giống toàn bộ đơn gốc
          const currentNow = new Date().toISOString();
          const draftOrderDate = isValidDate(draftHeader?.orderDate)
            ? draftHeader.orderDate
            : currentNow;
          const draftCreateDate = isValidDate(draftHeader?.createDate)
            ? draftHeader.createDate
            : currentNow;

          const draftOrderHeader = {
            ...originalHeader,
            id: draftHeader?.id || 0,
            orderNumber: draftHeader.orderNumber,
            orderDate: draftOrderDate,
            createDate: draftCreateDate,
            orderStatus: "DON_HANG_TAM",
            createBy: 0,
            lastUpdateBy: 0,
            lastUpdateDate: "",
            approveId: 0,
            approveNote: "",
            rejectNote: "",
            shippingCode: "",
          };

          // 5. Gọi API tạo mới đơn hàng trạng thái nháp
          const response = await repositoryPos.post<
            MessageResponse<dataCreateSalesOrder>
          >("/api/v1/CreateSellItem/create", {
            orderDetail: draftOrderDetail,
            orderHeader: draftOrderHeader,
            isRetun: false,
            isLock: false,
          });

          if (response && response.success) {
            NotificationExtension.Success(
              `Sao chép đơn hàng thành công! Mã đơn nháp mới: ${draftHeader.orderNumber}`,
            );
            SocketExtension.SendMessageToTopic<any>({
              topic: CREATEORDERSUCCESS,
              data: "",
            });
            await fetchData(false);

            // Kiểm tra khác ngày giữa đơn cũ và đơn mới
            const oldOrderDate = [
              originalHeader?.createDate,
              originalHeader?.orderDate,
              originalRow?.creationDate,
              originalRow?.createDate,
              originalRow?.orderDate,
            ].find((d) => isValidDate(d));

            const newOrderDate =
              [
                draftOrderHeader?.orderDate,
                draftOrderHeader?.createDate,
                draftHeader?.orderDate,
                draftHeader?.createDate,
              ].find((d) => isValidDate(d)) || currentNow;

            const isDifferentDate = Boolean(
              oldOrderDate &&
              newOrderDate &&
              !moment(oldOrderDate).isSame(moment(newOrderDate), "day"),
            );

            if (isDifferentDate) {
              modals.openConfirmModal({
                title: (
                  <Group gap="xs">
                    <IconAlertTriangle size={26} color="#f08c00" />
                    <Title order={4} c="orange.8">
                      Cảnh báo kiểm tra giá đơn hàng
                    </Title>
                  </Group>
                ),
                centered: true,
                size: "580px",
                children: (
                  <Box py="xs">
                    <Text size="md" lh={1.6}>
                      Sao chép đơn hàng{" "}
                      <Text span fw={700} size="lg">
                        {originalRow.orderNumber}
                      </Text>{" "}
                      thành công!
                    </Text>
                    <Text size="md" mt="xs" lh={1.6}>
                      Mã đơn nháp mới:{" "}
                      <Text span fw={700} c="blue" size="xl">
                        {draftHeader.orderNumber}
                      </Text>
                    </Text>

                    <Alert
                      mt="md"
                      p="md"
                      color="orange"
                      variant="light"
                      icon={<IconAlertTriangle size={26} />}
                      title={
                        <Text fw={700} size="md">
                          Lưu ý kiểm tra giá sản phẩm
                        </Text>
                      }
                    >
                      <Text size="md" lh={1.6}>
                        Đơn hàng gốc được lập ngày{" "}
                        <Text span fw={700}>
                          {moment(oldOrderDate).format("DD/MM/YYYY")}
                        </Text>
                        , khác với ngày của đơn mới (
                        <Text span fw={700}>
                          {moment(newOrderDate).format("DD/MM/YYYY")}
                        </Text>
                        ).
                      </Text>
                      <Text size="md" mt={8} fw={700} c="orange.9" lh={1.6}>
                        Vui lòng kiểm tra lại giá bán, chiết khấu và các chương
                        trình khuyến mãi của các sản phẩm trong đơn hàng mới!
                      </Text>
                    </Alert>
                  </Box>
                ),
                labels: { confirm: "Đã hiểu", cancel: "" },
                confirmProps: { color: "orange", size: "md" },
                cancelProps: { display: "none" },
              });
            } else {
              modals.openConfirmModal({
                title: (
                  <Group gap="xs">
                    <IconCheck size={26} color="#2b8a3e" />
                    <Title order={4} c="green.8">
                      Sao chép đơn hàng thành công
                    </Title>
                  </Group>
                ),
                centered: true,
                size: "480px",
                children: (
                  <Box py="xs">
                    <Text size="md" lh={1.6}>
                      Sao chép đơn hàng{" "}
                      <Text span fw={700} size="lg">
                        {originalRow.orderNumber}
                      </Text>{" "}
                      thành công!
                    </Text>
                    <Text size="md" mt="sm" lh={1.6}>
                      Mã đơn nháp mới:{" "}
                      <Text span fw={700} c="blue" size="xl">
                        {draftHeader.orderNumber}
                      </Text>
                    </Text>
                  </Box>
                ),
                labels: { confirm: "Đóng", cancel: "" },
                confirmProps: { color: "blue", size: "md" },
                cancelProps: { display: "none" },
              });
            }
          } else {
            NotificationExtension.Fails(
              response?.message || "Sao chép đơn hàng thất bại!",
            );
          }
        } catch (error) {
          console.error("Lỗi khi sao chép đơn hàng:", error);
          NotificationExtension.Fails("Đã xảy ra lỗi khi sao chép đơn hàng!");
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) =>
          String(row.original.shippingPriority) === "1" ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                size="md"
                style={{ cursor: "pointer" }}
                leftSection={<IconRocket size={12} />}
                color={"red"}
                onDoubleClick={() => handleCheckView(row)}
              >
                {renderedCellValue === null
                  ? "KHÔNG HỢP LỆ"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="md"
                style={{ cursor: "pointer" }}
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() => handleCheckView(row)}
              >
                {renderedCellValue === null
                  ? "KHÔNG HỢP LỆ"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ),
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "DON_CHO_DUYET_DOI_TRA":
              badgeColor = "orange";
              break;
            case "DON_DA_DUYET_DOI_TRA":
              badgeColor = "green";
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataStatusGeneral,
              "label",
            )?.toUpperCase() || renderedCellValue}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderType",
        header: "Loại đơn hàng",
        size: 150,
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const orderType = orderTypes.find(
            (type) => type.value === row.original.orderType?.toString(),
          );

          return (
            <Badge color={orderType?.color || "gray"}>
              {orderType?.label || "KHÔNG HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute16",
        header: "Mã ĐTCN",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "saleChannelId",
        header: "Kênh bán",
        Cell: ({ renderedCellValue }) => {
          const saleChannel = dataChannel.find(
            (channel) => channel.value === renderedCellValue?.toString(),
          );
          return saleChannel?.text || "KHÔNG HỢP LỆ";
        },
      },
      {
        accessorKey: "invOrgName",
        header: "Kho hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{`[${row.original.invOrgCode}] ${row.original.invOrgName}`}</>
        ),
      },
      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        enableColumnFilter: false,
      },
      {
        accessorKey: "nvhs",
        header: "Người hưởng số",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "salePhone",
        header: "Số đt người bán",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "creator",
        header: "Người tạo đơn đổi trả",
        // enableColumnActions: false,,
        size: 200,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          // Kiểm tra nếu orderType === 3 thì hiển thị, ngược lại không hiển thị
          return row.original.orderType == 3 ? <>{row.original.creator}</> : "";
        },
      },
      {
        accessorKey: "creationDate",
        header: "Ngày lập",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderDate",
        header: "Ngày hoàn thành",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "technicalChecked",
        header: "Dịch vụ kiểm tra",
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <>
            {
              <>
                {(() => {
                  if (row.original.technicalChecked === 0) {
                    return <Badge color="indigo">Không yêu cầu</Badge>;
                  } else if (row.original.technicalChecked === 1) {
                    return <Badge color="grape">Lắp ráp(mới)</Badge>;
                  } else if (row.original.technicalChecked === 2) {
                    return <Badge color="cyan">Kiểm tra(mới)</Badge>;
                  } else if (row.original.technicalChecked === 3) {
                    return (
                      <Badge color={sky_blue.medium}>
                        Lắp ráp(mới)+Kiểm tra(mới)
                      </Badge>
                    );
                  } else {
                    return null;
                  }
                })()}
              </>
            }
          </>
        ),
      },
      {
        accessorKey: "attribute11",
        header: "KT đã kiểm tra",
        size: 260,
        Cell: ({ row }) => (
          <Badge color="blue">
            {row?.original?.attribute11
              ? row?.original?.attribute11
              : "Khách không yêu cầu kiểm tra"}
          </Badge>
        ),
      },
      {
        accessorKey: "deliveryStatus",
        header: "Trạng thái giao vận",
        Cell: ({ renderedCellValue, row }) => (
          <Badge size="sm" color="cyan">
            {getShippingStatusLabel(row?.original?.deliveryStatus)}
          </Badge>
        ),
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "tenNVGV",
        header: "Tên NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "sdtNVGV",
        header: "SĐT NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute46",
        header: "Thời gian GV tiếp nhận đơn",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "attribute45",
        header: "Thời gian GV hoàn thành đơn",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ row }) =>
        //   String(row.original.orderNumber).includes("-DT") ? (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute63
        //         ? String(row.original.attribute63)?.split("-")[0]
        //         : row.original.customerName}
        //     </Text>
        //   ) : (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute36
        //         ? String(row.original.attribute36)?.split("-")[0]
        //         : row.original.customerName}
        //     </Text>
        //   ),
      },
      {
        accessorKey: "customerPhone",
        header: "SĐT khách hàng",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ row }) =>
        //   String(row.original.orderNumber).includes("-DT") ? (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute63
        //         ? String(row.original.attribute63)?.split("-")[1]
        //         : row.original.customerPhone}
        //     </Text>
        //   ) : (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute36
        //         ? String(row.original.attribute36)?.split("-")[1]
        //         : row.original.customerPhone}
        //     </Text>
        //   ),
      },
      {
        accessorKey: "attribute36",
        header: "Tên người mua",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) =>
          String(row.original.orderNumber).includes("-DT") ? (
            <Text fw={500} size="11.5px">
              {row.original.attribute63
                ? String(row.original.attribute63)?.split("-")[0]
                : ""}
            </Text>
          ) : (
            <Text fw={500} size="11.5px">
              {row.original.attribute36
                ? String(row.original.attribute36)?.split("-")[0]
                : ""}
            </Text>
          ),
      },
      {
        accessorKey: "attribute36v2",
        header: "SĐT người mua",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) =>
          String(row.original.orderNumber).includes("-DT") ? (
            <Text fw={500} size="12.5px">
              {row.original.attribute63
                ? String(row.original.attribute63)?.split("-")[1]
                : ""}
            </Text>
          ) : (
            <Text fw={500} size="12.5px">
              {row.original.attribute36
                ? String(row.original.attribute36)?.split("-")[1]
                : ""}
            </Text>
          ),
      },
      {
        accessorKey: "amount",
        header: "Số tiền",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "paid",
        header: "Đã trả",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "remaining",
        header: "Còn nợ",
        size: 160,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "attribute24",
        header: "PT thanh toán",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="11.5px">
            {renderedCellValue || "Thu tiền ngay"}
          </Text>
        ),
      },
      {
        accessorKey: "attribute39",
        header: "Mã voucher",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "printInvoiceCheck",
        header: "Xuất hóa đơn",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row.original.printInvoiceCheck}</>,
      },
      {
        accessorKey: "attribute27",
        header: "Số hóa đơn",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute42",
        header: "Lỗi GHTK",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute49",
        header: "Mã đơn hàng Shopee",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute65",
        header: "Thời gian tiếp nhận đơn",
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue?.toString())}
          </>
        ),
      },
      {
        accessorKey: "dateLock",
        header: "Thời gian chốt đơn",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue?.toString())}
          </>
        ),
      },
      {
        accessorKey: "attribute67",
        header: "Thời gian hoàn thành",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue?.toString())}
          </>
        ),
      },
      {
        accessorKey: "attribute68",
        header: "Thời gian hủy đơn",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue?.toString())}
          </>
        ),
      },
      {
        accessorKey: "attribute81",
        header: "Người duyệt đổi trả",
        size: 350,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "attribute72",
        header: "Nguồn đơn hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {String(renderedCellValue) === "1"
                ? "Website"
                : String(renderedCellValue) === "2"
                  ? "TMĐT"
                  : String(renderedCellValue) === "3"
                    ? "GameShop"
                    : ""}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute86",
        header: "Thông tin Marketing",
        size: 1200,
        maxSize: 1600,
        Cell: ({ renderedCellValue }) => {
          if (!renderedCellValue) return <></>;

          let parsed: any = renderedCellValue;
          try {
            if (typeof renderedCellValue === "string") {
              parsed = JSON.parse(renderedCellValue);
            }
          } catch (e) {
            parsed = renderedCellValue;
          }

          if (!parsed || typeof parsed !== "object") return <></>;

          const showUtmSource = !!parsed.utm_source;
          const showUtmMedium = !!parsed.utm_medium;
          const showUtmCampaign = !!parsed.utm_campaign;

          const hasAnyUtm = showUtmSource || showUtmMedium || showUtmCampaign;
          if (!hasAnyUtm) return <></>;

          const marketingSummaryText = [
            showUtmSource ? `Nguồn truy cập: ${parsed.utm_source}` : "",
            showUtmMedium ? `Hình thức tiếp cận: ${parsed.utm_medium}` : "",
            showUtmCampaign
              ? `Chương trình marketing: ${parsed.utm_campaign}`
              : "",
          ]
            .filter(Boolean)
            .join(" | ");

          // Không có đo DOM ở đây, nên dùng ngưỡng độ dài để quyết định hiển thị nút xem chi tiết
          const shouldShowDetailsButton = marketingSummaryText.length > 80;

          const openMarketingDetail = () => {
            modals.openConfirmModal({
              title: "Thông tin nguồn & chiến dịch marketing",
              children: (
                <Box p={16}>
                  {typeof parsed === "object" ? (
                    <>
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 8,
                        }}
                      >
                        {parsed.utm_source && (
                          <Box
                            style={{
                              display: "flex",
                              gap: "10px",
                              flex: "0 0 20px",
                            }}
                          >
                            <Text color="dimmed">Nguồn truy cập:</Text>
                            <Text fw={600}>{parsed.utm_source}</Text>
                          </Box>
                        )}
                        {parsed.utm_medium && (
                          <Box
                            style={{
                              display: "flex",
                              gap: "10px",
                              flex: "0 0 20px",
                            }}
                          >
                            <Text color="dimmed">Hình thức tiếp cận:</Text>
                            <Text fw={600}>{parsed.utm_medium}</Text>
                          </Box>
                        )}
                        {parsed.utm_campaign && (
                          <Box
                            style={{
                              display: "flex",
                              gap: "10px",
                              flex: "0 0 20px",
                            }}
                          >
                            <Text color="dimmed">Chương trình marketing:</Text>
                            <Text fw={600}>{parsed.utm_campaign}</Text>
                          </Box>
                        )}
                        {parsed.utm_term && (
                          <Box
                            style={{
                              display: "flex",
                              gap: "10px",
                              flex: "0 0 20px",
                            }}
                          >
                            <Text color="dimmed">Nhóm khách hàng:</Text>
                            <Text fw={600}>{parsed.utm_term}</Text>
                          </Box>
                        )}
                        {parsed.utm_content && (
                          <Box
                            style={{
                              display: "flex",
                              gap: "10px",
                              flex: "0 0 20px",
                            }}
                          >
                            <Text color="dimmed">Nội dung quảng cáo:</Text>
                            <Text fw={600}>{parsed.utm_content}</Text>
                          </Box>
                        )}
                      </Box>
                    </>
                  ) : (
                    <Text>{String(parsed)}</Text>
                  )}
                </Box>
              ),
              size: "lg",
              radius: "md",
              labels: { confirm: "Confirm", cancel: "Cancel" },
              onCancel: () => {},
              onConfirm: () => {},
              confirmProps: { display: "none" },
              cancelProps: { display: "none" },
            });
          };

          return (
            <Box
              style={{
                display: "flex",
                gap: 12,
                alignItems: "center",
                flexWrap: "nowrap",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              {shouldShowDetailsButton && (
                <Tooltip label="Xem chi tiết">
                  <ActionIcon
                    variant="subtle"
                    color="gray"
                    size="sm"
                    onClick={openMarketingDetail}
                    style={{ flex: "0 0 auto" }}
                  >
                    <IconDots size={16} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              )}
              {showUtmSource && (
                <Box style={{ display: "flex", gap: 6, flex: "0 0 auto" }}>
                  <Text color="dimmed" style={{ whiteSpace: "nowrap" }}>
                    Nguồn truy cập:
                  </Text>
                  <Text fw={600} style={{ whiteSpace: "nowrap" }}>
                    {parsed.utm_source}
                  </Text>
                </Box>
              )}

              {showUtmSource && showUtmMedium && (
                <Divider
                  orientation="vertical"
                  style={{ alignSelf: "stretch" }}
                />
              )}

              {showUtmMedium && (
                <Box style={{ display: "flex", gap: 6, flex: "0 0 auto" }}>
                  <Text color="dimmed" style={{ whiteSpace: "nowrap" }}>
                    Hình thức tiếp cận:
                  </Text>
                  <Text fw={600} style={{ whiteSpace: "nowrap" }}>
                    {parsed.utm_medium}
                  </Text>
                </Box>
              )}

              {(showUtmSource || showUtmMedium) && showUtmCampaign && (
                <Divider
                  orientation="vertical"
                  style={{ alignSelf: "stretch" }}
                />
              )}

              {showUtmCampaign && (
                <Box style={{ display: "flex", gap: 6, flex: "0 0 auto" }}>
                  <Text color="dimmed" style={{ whiteSpace: "nowrap" }}>
                    CTMK:
                  </Text>
                  <Text fw={600} style={{ whiteSpace: "nowrap" }}>
                    {parsed.utm_campaign}
                  </Text>
                </Box>
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 200,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, row }) => (
          <Flex gap={10}>
            <Tooltip label="Danh sách sản phẩm trong đơn">
              <ActionIcon
                size={26}
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={() =>
                  openModal(
                    row.original.orderDetail,
                    row.original.amount,
                    row.original.orderNumber,
                  )
                }
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>{" "}
            <Tooltip label="Copy đơn hàng">
              <ActionIcon
                size={26}
                variant="light"
                aria-label="Copy order"
                color="teal"
                onClick={() => handleCopyOrder(row.original)}
              >
                <IconCopy size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>{" "}
            <Tooltip label="Đăng ảnh giao hàng">
              <ActionIcon
                size={26}
                variant="light"
                aria-label="Đăng ảnh giao hàng"
                color="orange"
                onClick={() => openUploadImageModal(row.original.orderNumber)}
              >
                <IconPhotoUp size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            {/* imageChecked: null = chưa có ảnh, "N" = có ảnh chưa kiểm tra, "Y" = đã kiểm tra */}
            <Tooltip
              label={
                row.original.imageChecked === "Y"
                  ? "Ảnh giao hàng (đã kiểm tra)"
                  : row.original.imageChecked === "N"
                    ? "Ảnh giao hàng (chưa kiểm tra)"
                    : "Ảnh giao hàng"
              }
            >
              <Indicator
                color="red"
                size={8}
                offset={2}
                disabled={row.original.imageChecked !== "N"}
              >
                <ActionIcon
                  size={26}
                  variant={
                    row.original.imageChecked === "Y" ? "filled" : "light"
                  }
                  aria-label="Ảnh giao hàng"
                  color={row.original.imageChecked === "Y" ? "green" : "cyan"}
                  onClick={() =>
                    openImageModal(
                      row.original.orderNumber,
                      row.original.videoChecked,
                    )
                  }
                >
                  {row.original.imageChecked === "Y" ? (
                    <IconPhotoCheck size={20} stroke={1.5} />
                  ) : (
                    <IconPhoto size={20} stroke={1.5} />
                  )}
                </ActionIcon>
              </Indicator>
            </Tooltip>
            {/* {row?.original?.shipingVendor === "Giao hàng tiết kiệm" && (
              <Tooltip label="Đẩy lại GHTK">
                <ActionIcon
                  onClick={() => handeOrderGHTK(row.original.orderNumber)}
                  variant="light"
                  aria-label="Settings"
                  color="green"
                >
                  <IconTruckDelivery size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            )} */}
            {/* Nút mở shared link từ attribute1 */}
            {row?.original?.shipingVendor === "Ahamove" && (
              <Tooltip label="Mở link chia sẻ">
                <ActionIcon
                  size={26}
                  onClick={() => handleOpenSharedLink(row.original.orderNumber)}
                  variant="light"
                  aria-label="Open shared link"
                  color="blue"
                >
                  <IconExternalLink size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            )}
          </Flex>
        ),
      },
    ],
    [location.pathname, dataStatusGeneral],
  );

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem("columnPinningReadOnly");
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : { left: ["STT", "orderNumber"], right: ["action"] }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningReadOnly",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);
  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["STT", "orderNumber"],
        // right: ["DETAIL_ORDER", "action"],
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: height,
        minHeight: height,
        overflowX: "auto",
        overflowY: "visible",
      },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    // onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style:
        String(row.original.shippingPriority) === "1"
          ? {
              fontWeight: "500",
              fontSize: "11.5px",
              padding: "3px 8px",
              color: "red",
            }
          : { ...styleTableMantine, padding: "3px 8px" },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      // showAlertBanner: isError,
      // showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
      columnPinning,
    },
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // displayColumnDefOptions: {
    //   "mrt-row-select": {
    //     size: 1,
    //   },
    //   "mrt-row-expand": {
    //     size: 1,
    //   },
    // },
  });

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  // Hàm gọi API phòng ban
  const fetchDataDepartment = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDepartment/get-all",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data
        .filter((item: any) => item.departmentId && item.name)
        .map((item: any) => ({
          value: String(item.departmentId),
          label: item.name,
        }));
      setDataDepartment(filteredData);
    }
  };

  // Hàm lấy dữ liệu khách hàng
  const fetchDataCustomer = async (searchTerm: string) => {
    const query = searchTerm ? `KeySearch=${searchTerm}&` : "";
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmCustomer/get-select?${query}Skip=${1}&Take=${30}`,
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.filter(
        (item: any) => item.text !== null,
      );
      setDataListCustomer(filteredData);
    }
  };

  const debouncedFetchDataCustomer = React.useCallback((value: string) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = window.setTimeout(() => {
      fetchDataCustomer(value);
    }, 300);
  }, []);

  useEffect(() => {
    debouncedFetchDataCustomer(searchTerm);
  }, [searchTerm, debouncedFetchDataCustomer]);

  // Bảng lấp đầy phần còn lại của màn hình; chân trang (phân trang) luôn nằm ở đáy màn hình.
  // Đo vị trí thật của khung bảng thay vì trừ một hằng số, nên đúng với mọi chiều cao header / bộ lọc.
  useEffect(() => {
    const recalc = () => {
      const container = table.refs.tableContainerRef.current;
      const paper = table.refs.tablePaperRef.current;
      if (!container || !paper) return;
      const containerRect = container.getBoundingClientRect();
      // phần nằm dưới khung cuộn: thanh phân trang + viền
      const below = paper.getBoundingClientRect().bottom - containerRect.bottom;
      const main = container.closest("main");
      const bottomGap = main
        ? parseFloat(window.getComputedStyle(main).paddingBottom) || 0
        : 16;
      const next = Math.max(
        240,
        Math.floor(
          window.innerHeight -
            (containerRect.top + window.scrollY) -
            below -
            bottomGap,
        ),
      );
      setHeight((prev) => (Math.abs(prev - next) > 1 ? next : prev));
    };
    recalc();
    const raf = window.requestAnimationFrame(recalc);
    window.addEventListener("resize", recalc);
    // hàng lọc nhanh / chip / thanh phân trang đổi chiều cao -> tính lại
    const observer =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(recalc) : null;
    if (observer) {
      if (headerRef.current) observer.observe(headerRef.current);
      if (table.refs.bottomToolbarRef.current)
        observer.observe(table.refs.bottomToolbarRef.current);
    }
    return () => {
      window.cancelAnimationFrame(raf);
      window.removeEventListener("resize", recalc);
      observer?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isAccountant && !isSearchedRef.current) {
      return;
    }
    fetchData(false);
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    deleteViewStatus,
    refreshKeySearch,
  ]);

  useEffect(() => {
    SocketExtension.On(CREATEORDERSUCCESS, (arg: any) => {
      // fetchData();
      setIsHaveNewOrder(true);
    });
    return () => {
      SocketExtension.Off(CREATEORDERSUCCESS, () => {});
    };
  }, []);

  useEffect(() => {
    if (value && value.length > 0) {
      if (value[0]) {
        const startDate = value[0];
        const startDateISO = startDate
          ? new Date(
              startDate.getTime() - startDate.getTimezoneOffset() * 60000,
            ).toISOString()
          : "";
        handleChangeSearchValue(startDateISO, "startDate");
      } else {
        handleChangeSearchValue("", "startDate");
      }
      if (value[1]) {
        const endDate = value[1];
        const endDateISO = endDate
          ? new Date(
              endDate.getTime() - endDate.getTimezoneOffset() * 60000,
            ).toISOString()
          : "";

        handleChangeSearchValue(endDateISO, "endDate");
      } else {
        handleChangeSearchValue("", "endDate");
      }
    }
  }, [value]);

  useEffect(() => {
    const fetchEmployeeBy = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        const result = response.data;
        const formattedData = result.map((employee: any) => ({
          value: employee.code, // Giá trị cho "value"
          label: `${employee.fullname}-${employee.code}`, // Giá trị cho "label"
        }));
        // Lọc trùng theo "value": mỗi value chỉ giữ lại 1 object đầu tiên
        const uniqueData = Array.from(
          new Map(
            formattedData.map((item: any) => [item.value, item]),
          ).values(),
        );
        setListEmployeeSales(uniqueData); // Lưu mảng đã format (đã lọc trùng) vào state
      }
    };
    fetchEmployeeBy();
  }, []);

  useEffect(() => {
    Promise.all([fetchDataBranch(), fetchDataDepartment()]);
  }, []);

  // Cấu hình ô lọc ghim theo tài khoản: server thắng local; chưa có (null) hoặc lỗi mạng/404 thì giữ local
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/UserScreenConfig/get?screenCode=${QUICK_FILTER_SCREEN_CODE}&configKey=${QUICK_FILTER_CONFIG_KEY}`,
        true,
      );
      const raw = res?.success ? res?.data?.configValue : null;
      if (cancelled || typeof raw !== "string" || !raw) return;
      try {
        const ids = normalizePinned(JSON.parse(raw)?.pinned);
        if (ids) {
          setPinned(ids);
          writePinnedToStorage(ids);
          setQuickRowKey((k) => k + 1);
        }
      } catch {
        // JSON hỏng: giữ cấu hình local
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  // const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  // useEffect(() => {
  //   if (checkedPinSearch)
  //     setTimeout(() => {
  //       const runAsyncFunctions = async () => {
  //         const savedSearch = await SaveKeySearch(
  //           searchReturn,
  //           setSearchReturn,
  //           2
  //         );

  //         if (savedSearch) {
  //           setSearch(savedSearch);
  //           setRefreshKeySearch(savedSearch);
  //         }
  //       };
  //       runAsyncFunctions();
  //     }, 1000);
  //   fetchData();
  // }, [checkedPinSearch, window.location.pathname]);

  // useEffect(() => {
  //   if (!checkedPinSearch) {
  //     form.setValues((prev) => ({ ...prev, keySearch: "" }));
  //   }
  // }, [checkedPinSearch]);

  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={orderTypes.find((x) => x.value === option.value)?.color}
        radius="sm"
        variant="filled"
      ></Badge>
      {option.label}{" "}
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // ===== Ô lọc nhanh + Bộ lọc nâng cao =====
  const defaultDateRange = () => ({
    StartDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    ),
    EndDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    ),
  });
  // Giá trị "trống" của từng trường form (đúng kiểu đang dùng)
  const emptyValueOf = (field: string): any => {
    if (
      [
        "DepartmentId",
        "ListShippingStatus",
        "ListPaymentMethod",
        "ListOrderGeneralStatus",
        "ListOutWardStatus",
        "ListOrgId",
      ].includes(field)
    )
      return [];
    if (["FinishDate", "OwDate", "Attribute42", "IsOnline"].includes(field))
      return null;
    if (field === "SourceOrderType") return false;
    return "";
  };
  const afterFormValuesChanged = (fields: string[]) => {
    if (fields.includes("OrderNumber")) setOrderNumberSearch("");
    if (fields.includes("KeySearch")) setKeySearchWord("");
    setQuickRowKey((k) => k + 1);
    setDrawerKey((k) => k + 1);
  };
  // Xóa giá trị của một ô lọc (nút x trên chip); khoảng ngày lập quay về mặc định vì tìm kiếm bắt buộc có ngày
  const clearFilterValues = (def: QuickFilterDef) => {
    const patch: any = {};
    if (def.id === "ngayLap") {
      Object.assign(patch, defaultDateRange());
    } else {
      def.fields.forEach((f) => {
        patch[f] = emptyValueOf(f);
      });
    }
    form.setValues((prev) => ({ ...prev, ...patch }));
    afterFormValuesChanged(def.fields);
  };
  // Đặt lại toàn bộ điều kiện tìm kiếm về mặc định (không đổi ô nào đang ghim)
  const resetAllFilters = () => {
    const patch: any = { ...defaultDateRange(), SourceOrderType: false };
    QUICK_FILTER_DEFS.forEach((d) =>
      d.fields.forEach((f) => {
        if (f !== "StartDate" && f !== "EndDate") patch[f] = emptyValueOf(f);
      }),
    );
    form.setValues((prev) => ({ ...prev, ...patch }));
    afterFormValuesChanged(["OrderNumber", "KeySearch"]);
  };

  const quickFilterOptions: Record<string, any[] | undefined> = {
    ttDon: orderStatuses,
    loaiDon: orderTypes,
    nguonDon: isOnlineOptions,
    nguoiHuongSo: listEmployeeSales,
    boPhan: dataDepartment,
    ttGiaoVan: dataShippingStatus,
    boPhanGiao: shippingVendorOptions,
    loiGHTK: attribute42Options,
    ptThanhToan: dataPaymentMethod,
    ttChung: generalStatusOptions,
    ttKho: warehouseStatusOptions,
    chiNhanh: branchOptions,
    kenhBan: saleChannelOptions,
    utm: hasAttribute86Options,
    kiemTraAnh: imageCheckedOptions,
  };
  const optionLabel = (options: any[] | undefined, value: any): string => {
    if (!options) return String(value);
    const found = options.find(
      (o: any) => (typeof o === "string" ? o : o?.value) === String(value),
    );
    if (!found) return String(value);
    return typeof found === "string"
      ? found
      : (found.label ?? found.text ?? String(value));
  };
  // Chuỗi hiển thị giá trị hiện tại của ô lọc (null = chưa có giá trị)
  const quickFilterDisplay = (def: QuickFilterDef): string | null => {
    const values: any = form.getValues();
    if (def.id === "ngayLap") {
      const from = values.StartDate
        ? moment(values.StartDate).format("DD/MM/YYYY")
        : "";
      const to = values.EndDate
        ? moment(values.EndDate).format("DD/MM/YYYY")
        : "";
      return from || to ? `${from} – ${to}` : null;
    }
    const raw = values[def.fields[0]];
    if (raw === undefined || raw === null || raw === "" || raw === false)
      return null;
    if (Array.isArray(raw)) {
      return raw.length
        ? raw.map((v) => optionLabel(quickFilterOptions[def.id], v)).join(", ")
        : null;
    }
    if (def.kind === "date") return moment(raw).format("DD/MM/YYYY");
    if (def.kind === "select")
      return optionLabel(quickFilterOptions[def.id], raw);
    return String(raw).trim() || null;
  };

  // Lưu cấu hình ghim lên server (debounce 500 ms); thất bại thì báo và giữ bản local
  const savePinnedToServer = useDebouncedCallback(async (ids: string[]) => {
    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/UserScreenConfig/save",
      {
        screenCode: QUICK_FILTER_SCREEN_CODE,
        configKey: QUICK_FILTER_CONFIG_KEY,
        configValue: JSON.stringify({ v: 1, pinned: ids }),
      },
      true,
    );
    if (!res || !res.success) {
      NotificationExtension.Fails("Chưa lưu được cấu hình ô lọc");
    }
  }, 500);
  const applyPinned = (ids: string[]) => {
    const next = normalizePinned(ids) ?? DEFAULT_PINNED;
    setPinned(next);
    writePinnedToStorage(next);
    savePinnedToServer(next);
    setQuickRowKey((k) => k + 1);
  };
  const togglePin = (id: string) =>
    applyPinned(
      pinned.includes(id) ? pinned.filter((x) => x !== id) : [...pinned, id],
    );
  const restoreDefaultPinned = () => applyPinned(DEFAULT_PINNED);
  const closeDrawer = () => {
    setDrawerOpened(false);
    setQuickRowKey((k) => k + 1);
  };
  const openDrawer = () => {
    setDrawerKey((k) => k + 1);
    setDrawerOpened(true);
  };

  // Control của từng ô lọc: giữ nguyên control, state và tham số gửi BE như trước
  const renderQuickFilterControl = (id: string) => {
    switch (id) {
      case "maDon":
        return (
          <TextInput
            key={form.key("OrderNumber")}
            placeholder="Mã đơn hàng"
            type="text"
            leftSection={<IconFileSearch color="#15aabf" />}
            {...form.getInputProps("OrderNumber")}
            onChange={(e) => {
              form.getInputProps("OrderNumber").onChange(e);
              setOrderNumberSearch(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                if (
                  !isAccountant &&
                  (!form.getValues().OrderNumber ||
                    form.getValues().OrderNumber.trim().length < 12) &&
                  (!form.getValues().KeySearch ||
                    form.getValues().KeySearch.trim().length < 3)
                ) {
                  return;
                }
                fetchData();
              }
            }}
          />
        );
      case "tuKhoa":
        return (
          <TextInput
            leftSection={<IconSearch color="#15aabf" />}
            key={form.key("KeySearch")}
            width="100%"
            placeholder="Từ khoá"
            {...form.getInputProps("KeySearch")}
            onChange={(e) => {
              form.getInputProps("KeySearch").onChange(e);
              setKeySearchWord(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                if (
                  !isAccountant &&
                  (!form.getValues().OrderNumber ||
                    form.getValues().OrderNumber.trim().length < 12) &&
                  (!form.getValues().KeySearch ||
                    form.getValues().KeySearch.trim().length < 3)
                ) {
                  return;
                }
                fetchData();
              }
            }}
          />
        );
      case "ngayLap":
        return (
          <Flex gap={6} wrap="nowrap">
            <DatePickerInput
              leftSection={<IconCalendarUp color="#15aabf" />}
              size="sm"
              style={{ flex: 1, minWidth: 0 }}
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                form.getValues()?.StartDate
                  ? new Date(form.getValues()?.StartDate)
                  : null
              }
              onChange={(e) =>
                form.setValues((prev) => ({
                  ...prev,
                  StartDate: e
                    ? new Date(new Date(e).getTime() + 7 * 3600 * 1000)
                    : undefined,
                }))
              }
            />
            <DatePickerInput
              leftSection={<IconCalendarDown color="#15aabf" />}
              size="sm"
              style={{ flex: 1, minWidth: 0 }}
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                form.getValues()?.EndDate
                  ? new Date(form.getValues()?.EndDate)
                  : null
              }
              onChange={(e) =>
                form.setValues((prev) => ({
                  ...prev,
                  EndDate: e
                    ? new Date(new Date(e).getTime() + 7 * 3600 * 1000)
                    : undefined,
                }))
              }
            />
          </Flex>
        );
      case "ttDon":
        return (
          <Select
            key={form.key("orderStatus")}
            placeholder="Trạng thái đơn hàng"
            clearable
            leftSection={<IconStatusChange color="#15aabf" />}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={orderStatuses}
            {...form.getInputProps("orderStatus")}
          />
        );
      case "loaiDon":
        return (
          <Select
            key={form.key("OrderType")}
            searchable
            clearable
            placeholder="Loại đơn hàng"
            comboboxProps={{
              transitionProps: { transition: "fade-up", duration: 200 },
            }}
            leftSection={<IconMenuOrder color="#15aabf" />}
            data={orderTypes}
            nothingFoundMessage="Dữ liệu không có !"
            renderOption={renderSelectOption}
            {...form.getInputProps("OrderType")}
          />
        );
      case "nguonDon":
        return (
          <Select
            key={form.key("IsOnline")}
            placeholder="Loại đơn hàng"
            leftSection={<IconClipboardList color="#15aabf" />}
            data={isOnlineOptions}
            clearable
            {...form.getInputProps("IsOnline")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "chungTuGoc":
        return (
          <TextInput
            key={form.key("attribute19")}
            placeholder="Mã chứng từ gốc"
            leftSection={<IconSearch color="#15aabf" />}
            {...form.getInputProps("attribute19")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "serial":
        return (
          <TextInput
            key={form.key("Serial")}
            placeholder="Serial"
            type="text"
            leftSection={<IconNumbers color="#15aabf" />}
            {...form.getInputProps("Serial")}
            // defaultValue={searchReturn.Serial}
            // onChange={(e) => {
            //   handleChangeSearchReturn(e.target.value, "Serial");
            // }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "voucher":
        return (
          <TextInput
            key={form.key("VourcherCode")}
            placeholder="Mã vourcher"
            leftSection={<IconSearch color="#15aabf" />}
            {...form.getInputProps("VourcherCode")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "sdtKH":
        return (
          <TextInput
            key={form.key("Phone")}
            placeholder="SĐT khách hàng"
            type="text"
            leftSection={<IconNumbers color="#15aabf" />}
            {...form.getInputProps("Phone")}
            // defaultValue={searchReturn.Phone}
            // onChange={(e) => {
            //   handleChangeSearchReturn(e.target.value, "Phone");
            // }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "maKH":
        return (
          <TextInput
            key={form.key("CustomerCode")}
            placeholder="Mã khách hàng"
            type="text"
            leftSection={<IconCodeDots color="#15aabf" />}
            {...form.getInputProps("CustomerCode")}
            // defaultValue={searchReturn.CustomerCode}
            // onChange={(e) => {
            //   handleChangeSearchReturn(e.target.value, "CustomerCode");
            // }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "tenKH":
        return (
          <TextInput
            key={form.key("CustomerName")}
            placeholder="Tên khách hàng"
            type="text"
            leftSection={<IconUser color="#15aabf" />}
            {...form.getInputProps("CustomerName")}
            // defaultValue={searchReturn.CustomerName}
            // onChange={(e) => {
            //   handleChangeSearchReturn(e.target.value, "CustomerName");
            // }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "mst":
        return (
          <TextInput
            key={form.key("CustomerTaxCode")}
            placeholder="Mã số thuế"
            type="text"
            leftSection={<IconNumbers color="#15aabf" />}
            {...form.getInputProps("CustomerTaxCode")}
            // defaultValue={searchReturn.CustomerTaxCode}
            // onChange={(e) => {
            //   handleChangeSearchReturn(e.target.value, "CustomerTaxCode");
            // }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "sdtNguoiMua":
        return (
          <TextInput
            key={form.key("BuyerPhone")}
            placeholder="SĐT người mua"
            leftSection={<IconSearch color="#15aabf" />}
            {...form.getInputProps("BuyerPhone")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "sdtNguoiBan":
        return (
          <TextInput
            key={form.key("SalePhone")}
            placeholder="SĐT người bán"
            leftSection={<IconSearch color="#15aabf" />}
            {...form.getInputProps("SalePhone")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "nguoiHuongSo":
        return (
          <Select
            leftSection={<IconSearch color="#15aabf" />}
            key={listEmployeeSales.length || form.key("CodeSal")}
            placeholder="Tìm người hưởng số"
            data={listEmployeeSales}
            {...form.getInputProps("CodeSal")}
            // onChange={(value) => {
            //   handleChangeSearchReturn(String(value || ""), "CodeSal");
            // }}
            clearable
            searchable
          />
        );
      case "boPhan":
        return (
          <MultiSelect
            key={form.key("DepartmentId")}
            placeholder="Bộ phận"
            leftSection={<IconUser color="#15aabf" />}
            data={dataDepartment}
            searchable
            clearable
            {...form.getInputProps("DepartmentId")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "ttGiaoVan":
        return (
          <MultiSelect
            key={form.key("ListShippingStatus")}
            placeholder="Trạng thái giao vận"
            leftSection={<IconTruckDelivery color="#15aabf" />}
            data={dataShippingStatus}
            searchable
            clearable
            {...form.getInputProps("ListShippingStatus")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "boPhanGiao":
        return (
          <Select
            key={form.key("ShipingVendor")}
            placeholder="Tìm bộ phận giao hàng"
            data={shippingVendorOptions}
            {...form.getInputProps("ShipingVendor")}
            // onChange={(value) => {
            //   handleChangeSearchReturn(String(value || ""), "CodeSal");
            // }}
            leftSection={<IconTruckDelivery color="#15aabf" />}
            clearable
            searchable
          />
        );
      case "loiGHTK":
        return (
          <Select
            key={form.key("Attribute42")}
            placeholder="Lỗi GHTK"
            data={attribute42Options}
            {...form.getInputProps("Attribute42")}
            leftSection={<IconTruckDelivery color="#15aabf" />}
            clearable
            searchable
          />
        );
      case "ngayXuatKho":
        return (
          <DatePickerInput
            key={form.key("OwDate")}
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Ngày xuất kho"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            clearable
            {...form.getInputProps("OwDate")}
          />
        );
      case "tgHoanThanh":
        return (
          <DatePickerInput
            key={form.key("FinishDate")}
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Thời gian hoàn thành đơn"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            clearable
            {...form.getInputProps("FinishDate")}
          />
        );
      case "ptThanhToan":
        return (
          <MultiSelect
            key={form.key("ListPaymentMethod")}
            placeholder="PT thanh toán"
            leftSection={<IconCash color="#15aabf" />}
            data={dataPaymentMethod}
            searchable
            clearable
            {...form.getInputProps("ListPaymentMethod")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "ttChung":
        return (
          <MultiSelect
            key={form.key("ListOrderGeneralStatus")}
            placeholder="Trạng thái chung"
            leftSection={<IconListCheck color="#15aabf" />}
            data={generalStatusOptions}
            searchable
            clearable
            {...form.getInputProps("ListOrderGeneralStatus")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "ttKho":
        return (
          <MultiSelect
            key={form.key("ListOutWardStatus")}
            placeholder="Trạng thái kho"
            leftSection={<IconBuildingWarehouse color="#15aabf" />}
            data={warehouseStatusOptions}
            searchable
            clearable
            {...form.getInputProps("ListOutWardStatus")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "chiNhanh":
        return (
          <MultiSelect
            key={form.key("ListOrgId")}
            placeholder="Chi nhánh"
            leftSection={<IconBuildingStore color="#15aabf" />}
            data={branchOptions}
            searchable
            clearable
            {...form.getInputProps("ListOrgId")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "kenhBan":
        return (
          <Select
            key={form.key("saleChannelId")}
            placeholder="lọc theo kênh bán"
            leftSection={<IconSandbox color="#15aabf" />}
            data={saleChannelOptions}
            {...form.getInputProps("saleChannelId")}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
            }}
          />
        );
      case "utm":
        return (
          <Select
            key={form.key("HasAttribute86")}
            placeholder="Thông tin Marketing (UTM)"
            data={hasAttribute86Options}
            clearable
            searchable
            {...form.getInputProps("HasAttribute86")}
          />
        );
      case "kiemTraAnh":
        return (
          <Select
            key={form.key("ImageChecked")}
            placeholder="Kiểm tra ảnh giao hàng"
            leftSection={<IconPhotoCheck color="#15aabf" />}
            data={imageCheckedOptions}
            clearable
            {...form.getInputProps("ImageChecked")}
          />
        );
      default:
        return null;
    }
  };
  const quickFilterCatalog = QUICK_FILTER_DEFS.map((d) => ({
    ...d,
    render: () => renderQuickFilterControl(d.id),
  }));
  // Hàng lọc nhanh: các ô luôn hiện đứng đầu (Từ khóa, Khoảng ngày lập), sau đó các ô ghim theo thứ tự catalog
  const pinnedFilters = [
    ...quickFilterCatalog.filter((f) => ALWAYS_VISIBLE.includes(f.id)),
    ...quickFilterCatalog.filter(
      (f) => !ALWAYS_VISIBLE.includes(f.id) && pinned.includes(f.id),
    ),
  ];
  const extraFilters = quickFilterCatalog
    .filter((f) => !ALWAYS_VISIBLE.includes(f.id) && !pinned.includes(f.id))
    .map((f) => ({ ...f, display: quickFilterDisplay(f) }))
    .filter((f) => f.display !== null);

  return (
    <>
      <div
        // kéo lên phần đệm trên của khung nội dung (AppShell.Main) để bỏ khoảng trắng dưới header
        style={{ border: "1px solid #dee2e6", padding: "10px", marginTop: -12 }}
        ref={headerRef}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <div>
            <Button
              leftSection={<IconReload size={14} />}
              variant="blue"
              disabled={!isHaveNewOrder}
              mr={"xs"}
              onClick={() => {
                fetchData();
                setIsHaveNewOrder(false);
              }}
            >
              Cập nhật đơn mới
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              mr={"xs"}
              onClick={() => {
                if (form.getValues()?.StartDate && form.getValues()?.EndDate) {
                  const formValues = form.getValues();
                  const IsEcommerce =
                    formValues.IsOnline && formValues.IsOnline === "IsEcommerce"
                      ? "true"
                      : "false";
                  const queryParams = {
                    Skip: pagination.pageIndex * pagination.pageSize,
                    Take: pagination.pageSize,
                    CustomerName: formValues.CustomerName
                      ? formValues.CustomerName?.toString()
                      : "",
                    CustomerCode: formValues.CustomerCode
                      ? formValues.CustomerCode?.toString()
                      : "",
                    CustomerTaxCode: formValues.CustomerTaxCode
                      ? formValues.CustomerTaxCode?.toString()
                      : "",
                    Serial: formValues.Serial
                      ? formValues.Serial?.toString()
                      : "",
                    OrderNumber: formValues.OrderNumber
                      ? formValues.OrderNumber?.toString()?.toUpperCase()
                      : "",
                    Phone: formValues.Phone
                      ? formValues.Phone?.toString().trim()
                      : "",
                    KeySearch: formValues.KeySearch
                      ? formValues.KeySearch?.toString()
                      : "",
                    StartDate: new Date(formValues.StartDate)?.toISOString(),
                    EndDate: new Date(formValues.EndDate)?.toISOString(),
                    CodeSal: formValues.CodeSal
                      ? formValues.CodeSal?.toString()
                      : "",
                    ShipingVendor: formValues.ShipingVendor
                      ? formValues.ShipingVendor?.toString()
                      : "",
                    FinishDate: formValues.FinishDate
                      ? moment(formValues?.FinishDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    OwDate: formValues.OwDate
                      ? moment(formValues?.OwDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    SalePhone: formValues.SalePhone?.toString(),
                    VourcherCode: formValues.VourcherCode?.toString(),
                    Attribute42: formValues.Attribute42
                      ? formValues.Attribute42?.toString()
                      : "",
                    OrderType: formValues.OrderType
                      ? formValues.OrderType?.toString()
                      : "",
                    IsOnline:
                      formValues.IsOnline &&
                      formValues.IsOnline !== "IsEcommerce"
                        ? formValues.IsOnline
                        : "",
                    BuyerPhone: formValues.BuyerPhone
                      ? formValues.BuyerPhone
                      : "",
                    attribute19: formValues.attribute19
                      ? formValues.attribute19
                      : "",
                    saleChannelId: formValues.saleChannelId
                      ? formValues.saleChannelId
                      : "",
                    HasAttribute86: formValues.HasAttribute86
                      ? formValues.HasAttribute86?.toString()
                      : "",
                    ImageChecked: formValues.ImageChecked
                      ? formValues.ImageChecked
                      : "",
                    DepartmentId:
                      formValues?.DepartmentId &&
                      Array.isArray(formValues.DepartmentId) &&
                      formValues.DepartmentId.length > 0
                        ? formValues.DepartmentId
                        : [],
                    orderStatus: formValues.orderStatus
                      ? formValues.orderStatus
                      : "",
                    ListShippingStatus: Array.isArray(
                      formValues.ListShippingStatus,
                    )
                      ? formValues.ListShippingStatus
                      : [],
                    ListPaymentMethod: Array.isArray(
                      formValues.ListPaymentMethod,
                    )
                      ? formValues.ListPaymentMethod
                      : [],
                    ListOrderGeneralStatus: Array.isArray(
                      formValues.ListOrderGeneralStatus,
                    )
                      ? formValues.ListOrderGeneralStatus
                      : [],
                    ListOutWardStatus: Array.isArray(
                      formValues.ListOutWardStatus,
                    )
                      ? formValues.ListOutWardStatus
                      : [],
                    ListOrgId: Array.isArray(formValues.ListOrgId)
                      ? formValues.ListOrgId
                      : [],
                    SourceOrderType: formValues.SourceOrderType ? "4" : "",
                  };

                  const departmentIds = queryParams.DepartmentId || [];
                  const otherParams = Object.entries({
                    ...queryParams,
                    IsEcommerce: IsEcommerce,
                  })
                    .filter(
                      ([key, value]) =>
                        key !== "DepartmentId" &&
                        key !== "ListShippingStatus" &&
                        key !== "ListPaymentMethod" &&
                        key !== "ListOrderGeneralStatus" &&
                        key !== "ListOutWardStatus" &&
                        key !== "ListOrgId" &&
                        value !== undefined &&
                        value !== "",
                    )
                    .map(
                      ([key, value]) => `${key}=${encodeURIComponent(value)}`,
                    )
                    .join("&");

                  const departmentParams =
                    Array.isArray(departmentIds) && departmentIds.length > 0
                      ? departmentIds
                          .map((id) => `DepartmentId=${encodeURIComponent(id)}`)
                          .join("&")
                      : "";

                  let url;
                  url =
                    "/api/v1/CreateSellItem/export-sale-order?" +
                    otherParams +
                    (departmentParams ? "&" + departmentParams : "") +
                    buildListParams(
                      "ListShippingStatus",
                      queryParams.ListShippingStatus,
                    ) +
                    buildListParams(
                      "ListPaymentMethod",
                      queryParams.ListPaymentMethod,
                    ) +
                    buildListParams(
                      "ListOrderGeneralStatus",
                      queryParams.ListOrderGeneralStatus,
                    ) +
                    buildListParams(
                      "ListOutWardStatus",
                      queryParams.ListOutWardStatus,
                    ) +
                    buildListParams("ListOrgId", queryParams.ListOrgId);

                  const _url = BASE_API_POS + url;

                  const fullUrl = new URL(_url);

                  const token = localStorage.getItem("token");

                  fetch(fullUrl.toString(), {
                    method: "GET", // Use the appropriate HTTP method
                    headers: {
                      Authorization: `Bearer ${token?.replace(/"/g, "")}`,
                      "Content-Type": "application/vnd.ms-excel",
                    },
                  })
                    .then((response) => {
                      if (response.ok) {
                        return response.blob(); // Assuming the response is a file or blob
                      } else {
                        throw new Error("Failed to fetch the resource");
                      }
                    })
                    .then((blob) => {
                      // Open the blob in a new tab
                      const url = window.URL.createObjectURL(blob);
                      const _name = new Date().toISOString().slice(0, 10);
                      let filename = "bao_cao_ban_hang" + "-" + _name + ".xlsx"; // Tên mặc định nếu không có header
                      const link = document.createElement("a");
                      link.href = url;
                      link.download = filename;
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      window.URL.revokeObjectURL(url);
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                } else {
                  NotificationExtension.Fails(
                    "Vui lòng chọn khoảng thời gian Export Excel !",
                  );
                }
              }}
            >
              Export Excel
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              onClick={() => {
                if (form.getValues()?.StartDate && form.getValues()?.EndDate) {
                  const formValues = form.getValues();
                  const IsEcommerce =
                    formValues.IsOnline && formValues.IsOnline === "IsEcommerce"
                      ? true
                      : false;
                  const bodyParams = {
                    Skip: pagination.pageIndex * pagination.pageSize,
                    Take: pagination.pageSize,
                    CustomerName: formValues.CustomerName
                      ? formValues.CustomerName?.toString()
                      : "",
                    CustomerCode: formValues.CustomerCode
                      ? formValues.CustomerCode?.toString()
                      : "",
                    CustomerTaxCode: formValues.CustomerTaxCode
                      ? formValues.CustomerTaxCode?.toString()
                      : "",
                    Serial: formValues.Serial
                      ? formValues.Serial?.toString()
                      : "",
                    OrderNumber: formValues.OrderNumber
                      ? formValues.OrderNumber?.toString()?.toUpperCase()
                      : "",
                    Phone: formValues.Phone
                      ? formValues.Phone?.toString().trim()
                      : "",
                    KeySearch: formValues.KeySearch
                      ? formValues.KeySearch?.toString()
                      : "",
                    StartDate: new Date(formValues.StartDate)?.toISOString(),
                    EndDate: new Date(formValues.EndDate)?.toISOString(),
                    CodeSal: formValues.CodeSal
                      ? formValues.CodeSal?.toString()
                      : "",
                    ShipingVendor: formValues.ShipingVendor
                      ? formValues.ShipingVendor?.toString()
                      : "",
                    FinishDate: formValues.FinishDate
                      ? moment(formValues?.FinishDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    OwDate: formValues.OwDate
                      ? moment(formValues?.OwDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    SalePhone: formValues.SalePhone?.toString(),
                    VourcherCode: formValues.VourcherCode?.toString(),
                    Attribute42: formValues.Attribute42
                      ? formValues.Attribute42?.toString()
                      : "",
                    OrderType: formValues.OrderType
                      ? formValues.OrderType?.toString()
                      : "",
                    IsOnline:
                      formValues.IsOnline &&
                      formValues.IsOnline !== "IsEcommerce"
                        ? formValues.IsOnline
                        : "",
                    BuyerPhone: formValues.BuyerPhone
                      ? formValues.BuyerPhone
                      : "",
                    attribute19: formValues.attribute19
                      ? formValues.attribute19
                      : "",
                    saleChannelId: formValues.saleChannelId
                      ? formValues.saleChannelId
                      : "",
                    HasAttribute86: formValues.HasAttribute86
                      ? formValues.HasAttribute86?.toString()
                      : "",
                    ImageChecked: formValues.ImageChecked
                      ? formValues.ImageChecked
                      : "",
                    DepartmentId:
                      formValues?.DepartmentId &&
                      Array.isArray(formValues.DepartmentId) &&
                      formValues.DepartmentId.length > 0
                        ? formValues.DepartmentId
                        : [],
                    orderStatus: formValues.orderStatus
                      ? formValues.orderStatus
                      : "",
                    ListShippingStatus: Array.isArray(
                      formValues.ListShippingStatus,
                    )
                      ? formValues.ListShippingStatus
                      : [],
                    ListPaymentMethod: Array.isArray(
                      formValues.ListPaymentMethod,
                    )
                      ? formValues.ListPaymentMethod
                      : [],
                    ListOrderGeneralStatus: Array.isArray(
                      formValues.ListOrderGeneralStatus,
                    )
                      ? formValues.ListOrderGeneralStatus
                      : [],
                    ListOutWardStatus: Array.isArray(
                      formValues.ListOutWardStatus,
                    )
                      ? formValues.ListOutWardStatus
                      : [],
                    ListOrgId: Array.isArray(formValues.ListOrgId)
                      ? formValues.ListOrgId
                      : [],
                    SourceOrderType: formValues.SourceOrderType ? "4" : "",
                    IsEcommerce: IsEcommerce,
                  };

                  const cleanedBody = Object.fromEntries(
                    Object.entries(bodyParams).filter(([, value]) => {
                      if (value === undefined || value === null || value === "")
                        return false;
                      if (Array.isArray(value)) return value.length > 0;
                      return true;
                    }),
                  );

                  const url =
                    "/api/v1/CreateSellItem/export-sale-order-background";

                  const _url = BASE_API_POS + url;

                  const token = localStorage.getItem("token");

                  fetch(_url, {
                    method: "POST", // Use the appropriate HTTP method
                    headers: {
                      Authorization: `Bearer ${token?.replace(/"/g, "")}`,
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cleanedBody),
                  })
                    .then((response) => {
                      if (response.ok) {
                        NotificationExtension.Success(
                          "Export Excel SLL thành công vui lòng kiểm tra và tải xuống file trong thông báo hoặc kho báo cáo (cá nhân) sau ít phút !",
                        );
                      } else {
                        throw new Error("Failed to fetch the resource");
                      }
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                } else {
                  NotificationExtension.Fails(
                    "Vui lòng chọn khoảng thời gian Export Excel !",
                  );
                }
              }}
            >
              Export Excel SLL
            </Button>
          </div>
        </Flex>
        <Stack gap={8} mt={8}>
          {/* Hàng lọc nhanh (trái) + các nút đặt bên phải các hàng lọc */}
          <Flex gap={8} align="flex-start" wrap="wrap">
            <Box
              key={quickRowKey}
              role="group"
              aria-label="Lọc nhanh"
              style={{
                flex: "1 1 600px",
                minWidth: 0,
                display: "grid",
                // track nửa cột (100px) để ô có thể rộng 1.5 cột; ô thường chiếm 2 track như trước
                gridTemplateColumns:
                  "repeat(auto-fill, minmax(min(100px, 100%), 1fr))",
                gap: 8,
                alignItems: "center",
              }}
            >
              {pinnedFilters.map((f) => (
                <Box
                  key={f.id}
                  style={{
                    gridColumn: `span ${Math.round((f.span ?? 1) * 2)}`,
                    minWidth: 0,
                  }}
                >
                  {f.render()}
                </Box>
              ))}
            </Box>
            <Box
              style={{
                flex: "0 0 auto",
                display: "grid",
                gridTemplateColumns: "repeat(2, auto)",
                gap: 8,
                alignItems: "center",
              }}
            >
              <Button
                variant="default"
                leftSection={
                  <IconAdjustmentsHorizontal size={16} color="#15aabf" />
                }
                rightSection={
                  extraFilters.length > 0 ? (
                    <Badge size="sm" circle color="blue">
                      {extraFilters.length}
                    </Badge>
                  ) : undefined
                }
                onClick={openDrawer}
                aria-expanded={drawerOpened}
                aria-controls="drawer-bo-loc-nang-cao"
              >
                Bộ lọc nâng cao
              </Button>
              <Checkbox
                label="Đơn Mobile"
                key={form.key("SourceOrderType")}
                {...form.getInputProps("SourceOrderType", { type: "checkbox" })}
              />
              <Button variant="default" onClick={resetAllFilters}>
                Đặt lại
              </Button>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                disabled={
                  !isAccountant &&
                  (!orderNumberSearch ||
                    orderNumberSearch.trim().length < 12) &&
                  (!keySearchWord || keySearchWord.trim().length < 3)
                }
                onClick={async () => {
                  if (
                    !isAccountant &&
                    (!form.getValues().OrderNumber ||
                      form.getValues().OrderNumber.trim().length < 12) &&
                    (!form.getValues().KeySearch ||
                      form.getValues().KeySearch.trim().length < 3)
                  ) {
                    return;
                  }
                  await fetchData();
                  // localStorage.setItem(
                  //   "allValueKeySearch",
                  //   JSON.stringify({
                  //     ...(window.location.pathname === "/sell/sales-order-list"
                  //       ? search
                  //       : searchReturn),
                  //     url: String(window.location.pathname),
                  //   })
                  // );
                }}
              >
                Tìm kiếm
              </Button>
            </Box>
          </Flex>
          {/* Chỉ hiện khi có ô chưa ghim nhưng đang có giá trị */}
          {extraFilters.length > 0 && (
            <Flex gap={6} wrap="wrap" align="center">
              <Text size="sm" c="dimmed">
                Đang lọc thêm:
              </Text>
              {extraFilters.map((f) => (
                <Pill
                  key={f.id}
                  size="md"
                  withRemoveButton
                  onRemove={() => clearFilterValues(f)}
                  removeButtonProps={{ "aria-label": `Bỏ lọc ${f.labelShort}` }}
                >
                  {f.labelShort}: <b>{f.display}</b>
                </Pill>
              ))}
              <Button
                variant="subtle"
                color="red"
                size="compact-sm"
                onClick={() =>
                  extraFilters.forEach((f) => clearFilterValues(f))
                }
              >
                Xóa tất cả
              </Button>
            </Flex>
          )}
        </Stack>
      </div>
      <Drawer
        id="drawer-bo-loc-nang-cao"
        opened={drawerOpened}
        onClose={closeDrawer}
        position="right"
        size={440}
        title={<Text fw={600}>Bộ lọc nâng cao</Text>}
        styles={{
          content: { display: "flex", flexDirection: "column" },
          body: {
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            paddingBottom: 0,
          },
        }}
      >
        <Flex
          justify="space-between"
          align="center"
          gap={12}
          pb={8}
          style={{ borderBottom: "1px solid #dee2e6" }}
        >
          <Text size="sm" c="dimmed">
            Ô vuông cạnh mỗi ô lọc: tích để đưa ô đó ra hàng lọc nhanh.
          </Text>
          <Text size="sm" style={{ whiteSpace: "nowrap" }}>
            Đang ra ngoài <b>{pinned.length}</b>/
            {quickFilterCatalog.length - ALWAYS_VISIBLE.length}
          </Text>
        </Flex>
        <ScrollArea
          key={drawerKey}
          style={{ flex: 1, minHeight: 0 }}
          offsetScrollbars
        >
          <Stack gap={14} py={8}>
            {QUICK_FILTER_GROUPS.map((group) => (
              <Box
                key={group}
                component="fieldset"
                style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}
              >
                <Text
                  component="legend"
                  size="xs"
                  fw={600}
                  tt="uppercase"
                  c="dimmed"
                  mb={6}
                  style={{ letterSpacing: "0.04em" }}
                >
                  {group}
                </Text>
                <Stack gap={8}>
                  {quickFilterCatalog
                    .filter(
                      (f) =>
                        f.group === group && !ALWAYS_VISIBLE.includes(f.id),
                    )
                    .map((f) => {
                      const isPinned = pinned.includes(f.id);
                      return (
                        <Flex key={f.id} align="center" gap={8} wrap="nowrap">
                          <Box style={{ flex: "1 1 auto", minWidth: 0 }}>
                            {f.render()}
                          </Box>
                          <Tooltip
                            label={
                              isPinned
                                ? "Đang hiện ở hàng lọc nhanh. Bỏ tích để rút về đây."
                                : "Tích để đưa ô lọc này ra hàng lọc nhanh."
                            }
                            position="left"
                            withArrow
                          >
                            <Box
                              component="span"
                              style={{ display: "inline-flex" }}
                            >
                              <Checkbox
                                checked={isPinned}
                                onChange={() => togglePin(f.id)}
                                aria-label={
                                  isPinned
                                    ? `Đang hiện ${f.labelShort} ở hàng lọc nhanh. Bỏ tích để rút về bộ lọc nâng cao`
                                    : `Tích để đưa ${f.labelShort} ra hàng lọc nhanh`
                                }
                              />
                            </Box>
                          </Tooltip>
                        </Flex>
                      );
                    })}
                </Stack>
              </Box>
            ))}
          </Stack>
        </ScrollArea>
        <Flex
          justify="space-between"
          align="center"
          gap={8}
          py={12}
          style={{ borderTop: "1px solid #dee2e6", background: "#fff" }}
        >
          <Button variant="default" onClick={restoreDefaultPinned}>
            Khôi phục mặc định
          </Button>
          <Group gap={8}>
            <Button variant="default" onClick={resetAllFilters}>
              Đặt lại
            </Button>
            <Button color="blue" onClick={closeDrawer}>
              Áp dụng
            </Button>
          </Group>
        </Flex>
      </Drawer>
      <div className="mt-5" style={{ marginTop: "8px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default SalesOrderListListReturn;
